{
  "AlertsScreens": {
    "alertsTemplates": "Alertər üzrə tənzimləmələr",
    "changeExecutor": "İcraçını dəyişdir",
    "changeStatus": "Statusu dəyişdir",
    "errors": {
      "failedLoadAlertDetails": "Alertlər üzrə ətraflı məlumatları yükləmək mümkün olmadı",
      "failedLoadAlertsList": "Alert siyahısnı yükləmək mümkün olmadıi",
      "fieldNotEmptyAndMin3": "Bu sahə boş buraxılmamalı və üç simvoldan az olmalıdır",
      "displayScheduleErrorMsg": "Cron ifadəsi üzrə yanlış sintaksis",
      "invalidInitialSchedule": "Cron cədvəli üzrə yanlış sintaksis",
      "invalidSchedule": "Cron cədvəlində xəta"
    },
    "excludeFromReport": "Siyahıdan  çıxar",
    "excludeReason": "Müvafiq çıxarılma səbəbini qeyd edin",
    "excludedFromReport": "Siyahıdan çıxarıldı",
    "executionHistory": "Alertin icra jurnalı",
    "manualStart": "Manual qaydada formalaşdırılmış alert",
    "returnToReport": "Siyahıya  qayıt",
    "runNow": "Alerti formalaşdır",
    "scheduledStart": "Avtomatlaşdırılmış qaydada  formalaşdırılmış alert ",
    "showDetailedInfo": "Ətraflı məlumat",
    "extendedInfo": {
      "blockedCashBoxesCount": "Bloklanmış kassaların sayı",
      "cashBoxesCount": "NKA sayı",
      "punchedDocuments": "Vurulmuş çeklərin sayı",
      "vatSum": "Vergi məbləği",
      "vatPercent": "Vergi dərəcəsi",
      "documentSum": "Çekin məbləği",
      "documentGlobalNumber": "Kassa çekinin nömrəsi",
      "gapSize": "İtirilən çeklərin sayı (boşluq)",
      "finalDocumentId": "Yekun fiskal İD",
      "finalDocumentSum": "Çekin yekun məbləği",
      "initialDocumentId": "İlkin fiskal İD",
      "initialDocumentSum": "Çekin ilkin məbləği",
      "finalDocumentGlobalNumber": "Yekun kassa çekinin nömrəsi",
      "initialDocumentGlobalNumber": "İlkin kassa çekinin nömrəsi",
      "status": "Vəziyyət",
      "details": "Daha ətraflı",
      "createdAtUtc": "Yaradılma tarixi",
      "cashBoxRegDateAtUtc": "NKA-nin qeydiyyat tarixi",
      "companyName": "Vergi ödəyicisinin adı",
      "insertedAtUtc": "Kassa çekinin alınma tarixi",
      "cashBoxTaxNumber": "NMQ-nin qeydiyyat nömrəsi",
      "companyTaxNumber": "VÖEN",
      "sum": "Məbləğ",
      "referencedDocId": "Ləğv etmə çeki/Geri qaytarma çeki",
      "certificateEndDateAtUtc": "Sertifikatın bitmə tarixi",
      "timeDelta": "Vaxt düzgünlüyü (saniyə)",
      "lastOnlineAtUtc": "Onlayn vaxtı",
      "lastDocCreatedAtUtc": "Son çekin formalaşdırma tarixi",
      "lastDocInsertedAtUtc": "Son çekin alınma tarixi",
      "invalidGpsCashBox": "NKA üzrə yanlış/mövcud olmayan GPS koordinatları",
      "invalidGpsCashBoxCreatedAtUtc": "Yanlış/mövcud olmayan GPS koordinatların ilkin müəyyən olunma tarixi",
      "invalidGpsStore": "Obyekt üzrə yanlış/mövcud olmayan koordinatlar",
      "storeTotal": "Obyeklərin sayı",
      "daysBetweenLastDocumentCreated": "Sonuncu kassa çekinin alınma tarixindən keçmiş müddət (tam gün sayı)",
      "cashBoxOfflineDate": "NKA-nın oflayna düşmə tarixi",
      "daysBetweenOffline": "Oflayn dövrü (günlər)",
      "cashBoxStatus": "NKA-nın vəziyyəti"
    },
    "rules": {
      "title": "Alertlər üzrə qaydaların təyin edilməsi",
      "addRule": "Qayda əlavə et",
      "id": "ID",
      "ruleType": "Qaydanın tipi",
      "taxNumber": "Unikal göstərici",
      "ruleEntityType": "Obyekt üzrə qayda tipi",
      "insertedAtUtc": "Yaradılma tarixi",
      "searchFieldHint": "Unikal göstərici üzrə axtarış",
      "editRule": "Qaydanı dəyiş",
      "deleteRuleModalTitle": "Siz bu qaydanı silmək istəyirsiniz?",
      "deleteRulesModalTitle": "Siz seçilmiş qaydaları silmək istəyirsiniz?",
      "ids": "IDs",
      "errors": {
        "rulesListNotFound": "Qaydalar üzrə siyahı tapılmadı",
        "addRuleError": "Qaydanı əlavə etmək mümkün olmadı",
        "editRuleError": "Qaydanı redaktə etmək mümkün olmadı",
        "deleteRulesError": "Qaydaları silmək mümkün olmadı",
        "failedDownloadRulesList": "Qaydalar üzrə siyahını yükləmək mümkün olmadı",
        "failedLoadTaxNumbersList": "Unikal identifikatorlar siyahısını yükləmək mümkün olmadı",
        "failedDownloadRuleTemplate": "Şablonu yükləmək mümkün olmadı"
      },
      "loadRulesViaExcel": "Qaydaları excel vasitəsilə yükləyin",
      "getRulesTemplate": "Faylın şablonunu yüklətin",
      "invalidFile": "Fayl şablona uyğun deyil",
      "deleteAllRules": "Yeni qaydaları yükləməzdən əvvəl köhnə qaydaları silin",
      "dropZoneFileText": "Mövcud excel faylını bura sürüşdürün və ya seçmək üçün klikləyin"
    },
    "editSchedule": "Alert siyahısının redaktə olunması"
  },
  "AuthScreen": {
    "backToLoginForm": "Giriş ekranına qayıt",
    "errors": {
      "loginError": "Giriş uğursuz oldu: {{errorText}}",
      "invalidPhoneNumber": "Yanlış telefon nömrəsi",
      "noAccessibleSections": "Hesabınız üçün heç bir bölmə mövcud deyil",
      "operatorsNotFound": "Operatorlar tapılmadı",
      "requiredField": "Bu sahəni doldurun",
      "requiredFieldsNotFilled": "Zəruri sahələr doldurulmayıb",
      "wrongEmailOrPassword": "Səhv giriş və ya şifrə",
      "rejectedByRecaptcha": "Giriş qadağandır. Hərəkətləriniz reCAPTCHA xidməti tərəfindən şübhəli olaraq qiymətləndirilib, bir müddət sonra yenidən avtorizasiya etməyə cəhd edin. (SUSPICIOUS statusu {{leftTime}} dəqiqədən sonra götürüləcək)"
    },
    "login": "Daxil ol",
    "logout": "Çıxmaq",
    "sendCode": "Göndər",
    "rememberMe": "Yadda saxla",
    "serviceProvider": "Xidmət provayderi",
    "waitingForCustomerConfirmation": "Lütfən, telefonunuza göndərilmiş sorğunu qəbul edin. Sorğunun yoxlama kodunun aşağıdakı kod ilə eyni olmasını müqayisə edin."
  },
  "DashboardScreens": {
    "cashboxesByOperators": "Operatorlar üzrə NKA-lar",
    "coverage": "Əhatə dairəsi",
    "documentsCounter": "Kassa çeklərinin sayğacı",
    "documentsCounts": {
      "avg": "Orta",
      "max": "Maksimum",
      "min": "Minimum"
    },
    "errors": {
      "failedLoadDocsCountsStat": "Kassa çeklərinin sayı  üzrə məlumatları yükləmək mümkün olmadı",
      "failedLoadDocsStat": "Kassa çekləri üzrə  məlumatları yükləmək mümkün olmadı",
      "failedToLoadCashboxStat": "NKA üzrə məlumatları yükləmək mümkün olmadı",
      "failedToLoadDevicesCountsStat": "NMQ-lərin sayı barədə məlumatları yükləmək mümkün olmadı",
      "failedToLoadOperatorCashBoxesStat": "Operatorun NKA-larını yükləmək mümkün olmadı",
      "failedToLoadPaymentTypesStat": "Ödəniş növləri üzrə məlumatları yükləmək mümkün olmadı",
      "failedToLoadRegistryItemsStat": "Reyestr göstəriciləri üzrə məlumatları yükləmək mümkün olmadıi",
      "failedToLoadTurnoversByActivity": "Fəaliyyətə üzrə dövriyyə məlumatlarını yükləmək mümkün olmadı"
    },
    "top": "Ən yaxşı {{limit}}"
  },
  "MainScreen": {
    "downloadInPDF": "PDF olaraq yükləyin",
    "downloadAsJPG": "Çeki yüklə",
    "errors": {
      "documentDuplicate": "Xahiş olunur, NMQ-nin qeydiyyat nömrəsini daxil edin \"{{documentId}}\"",
      "documentForCashboxNotFound": "NKA üzrə \"{{documentId}}\" kassa çeki \"{{taxNumber}}\" tapılmadı.",
      "documentNotFound": "Kassa çeki tapılmamışdır.",
      "documentNotFoundText": "Çek yarandığı andan 7 gün ərzində tapılmadığı halda çeki əlavə etməklə onlayn qaydada Dövlət Vergi Xidmətinə müraciət edin.",
      "invalidDocumentId": "Yanlış kassa çeki identifikatoru",
      "serverError": "Kassa çeki serverdə baş vermiş xəta səbəbindən tapılmadı",
      "forbidden": "Girişdən imtina xətası"
    },
    "linkToParentReceipt": "Müvafiq çekə keçid",
    "linksToParentsReceipts": "Müvafiq çeklərə keçidlər",
    "searchDocumentByIdPlaceholder": "Fiskal İD",
    "searchDocumentByTaxNumberPlaceholder": "NMQ-nin qeydiyyat nömrəsi",
    "watermarkTestWarning": "Bu qəbz alış əməliyyatını təsdiq etmir. Yalnız test üçündür!",
    "watermarkTestHint": "Sözü gedən alış qəbzini aldığınız təqdirdə Dövlət Vergi Xidmətinə müraciət etməyiniz xahiş olunur."
  },
  "MapScreen": {
    "clearFilter": "Axtarış filtrini sil",
    "lat": "Enlik",
    "lng": "Uzunluq",
    "geographiCoordinates": "Coğrafi koordinatlar",
    "coordinates": "Кoordinatlar",
    "onlyPortableCashboxesAreShown": "Nəzərə alın ki, yalnız portativ NKA-lar təsvir olunur"
  },
  "RegistryScreens": {
    "byCashboxes": "NKA-lar üzrə",
    "byObjects": "Obyektlər üzrə",
    "byPeriods": "Tarixlər üzrə",
    "cashBoxAlertsHistory": "NKA-nın alertləri  üzrə göstəricilər",
    "cashBoxAuditHistory": "NKA-nın texniki auditi üzrə məlumatlar",
    "cashBoxStateHistory": "NKA-nın rejimləri üzrə göstəricilər",
    "cashBoxStatusHistory": "NKA-nın vəziyyəti üzrə göstəricilər",
    "cashBoxReplacementHistory": "Müvəqqəti NKA-ların quraşdırılması üzrə məlumatlar",
    "cashBoxTimeHistory": "NKA-nın vaxtı üzrə göstəricilər",
    "cashBoxesRangeSelectHint": "Qeydiyyatdan çıxarılmış NKA-lar istisna olmaqla",
    "cashBoxesTotal": "NKA-lar (cəmi)",
    "completeAttestation": "Attestasiyanı bitir",
    "countOfCashRegisters": "NKA-ların sayı",
    "countOfCashboxes": "NKA sayı",
    "countOfObjects": "Obyekt sayı",
    "devicesInStock": "NMQ-lər (stokda)",
    "documentation": "Sənədlər",
    "errors": {
      "cashBoxesRequestFailed": "NKA-lar üzrə sorğu alınmadı",
      "cashBoxesStatsNotFound": "NKA-lar üzrə statistik məlumatları əldə etmək mümkün olmadı",
      "cashRegisterModelNotFound": "\"{{searchText}}\" adlı NKA modeli tapılmadı",
      "cashRegistersModelsListReqFailed": "NKA modellərinin siyahısı üzrə sorğu alınmadı",
      "cashboxNotFound": "\"{{searchText}}\" nömrəli NKA tapılmadı",
      "cashboxesListNotFound": "NKA-lar tapılmadı!",
      "companiesListNotFound": "Vergi ödəyiciləri tapılmadı",
      "companyNotFound": "\"{{searchText}}\" adlı vergi ödəyicisi tapılmadı",
      "documentsNotFound": "Kassa çekləri tapılmadı",
      "documentsRequestFailed": "Kassa çekləri üzrə sorğu alınmadı",
      "failedLoadFactoryNumbers": "Kassa aparatlarının siyahısnı yükləmək mümkün olmadı",
      "fieldNotEmpty": "Bu sahə boş buraxılmamalıdır",
      "operatorDataNotFound": "Operator barədə məlumatlar tapılmadı",
      "operatorNotFound": " \"{{searchText}}\" adlı operator tapılmadı",
      "operatorsListNotFound": "Operatorların siyahısını yükləmək mümkün olmadı",
      "storeWithTaxNumberNotFound": " \"{{searchText}}\" kodlu obyekt tapılmadı",
      "storesListNotFound": "Obyektlər tapılmadı",
      "storesRequestFailed": "Obyekt üzrə sorğu alınmadı",
      "turnoversRequestFailed": "Dövriyyə məlumatları üzrə sorğu alınmadıi",
      "enterIntegerValue": "Tam ədədi daxil edin 1-dən 100-dək",
      "maxDatesRange": "Maksimal tarix aralığı 3 il təşkil edir",
      "documentsExtendedDataNotFound": "Çek siyahısı üzrə ətraflı məlumat sorğusu uğursuz oldu",
      "devicesListNotFound": "NMQ-lərin siyahısını yükləmək mümkün olmadı",
      "deviceNotFound": "\"{{ id }}\" tapılmadı",
      "cahboxNotRegistered": "NKA qeydiyyata alınmayıb",
      "emptyLatitude": "Enlik boş buraxıla bilməz",
      "emptyLongitude": "Uzunluq boş buraxıla bilməz",
      "updateStoreInfoFailed": "Obyekt məlumatlarını yeniləmək mümkün olmadı",
      "latitudeOutOfBounds": "Enliyi daxil edin ({{min}} - {{max}})",
      "longitudeOutOfBounds": "Uzunluğu daxil edin ({{min}} - {{max}})",
      "fileToBig": "Faylın həcmi iridir",
      "fileToSmall": "Fayl çox kiçik",
      "storeOutOfAzBounds": "Obyekt tələb olunan bölgədən kənardadır",
      "allowableLongitudeRange": "İcazə verilən uzunluq diapazonu: {{min}} - {{max}}",
      "allowableLatitudeRange": "İcazə verilən enlik diapazonu: {{min}} - {{max}}",
      "updateInOffline": "Yenilənmə yalnız Onlayn rejimdə mümkündür",
      "firmwareUpdateNoSuitableVersions": "Yeniləmə üçün uyğun versiyaların siyahısı yoxdur",
      "waitingForSuitableVersionsList": "Versiyaların yenilənməsi üzrə siyahı əldə olunur...",
      "getSuitableTargetVersionsFailed": "Yenilənə bilən NMQ proqram təminatı versiyalarının siyahısını əldə etmək mümkün olmadı",
      "firmwareUpdateNotNeeded": "Cari versiya aktualdır. Yeniləməyə ehtiyac yoxdur",
      "firmwareUpdateForOldVersion": "Yenilənmə yalnız {{version}} yuxarı olan proqram versiyaları üçün mümkündür",
      "cashboxOutOfAzBounds": "NKA tələb olunan bölgədən kənardadır",
      "cashboxLocationDataNotFound": "NKA-nın yerləşim nöqtəsi barədə məlumatlar tapılmadı",
      "versionError": "Versiya adı 1-dən {{maxLength}} simvola qədər olmalıdır. Zəhmət olmasa yalnız rəqəmlərdən və aşağıdakı simvol dəstindən istifadə edin: v  .  -",
      "emptyAttestationResult": "Zəhmət olmasa attestasiyanın nəticələrini seçin",
      "cashRegisterModelVersionsNotFound": "Bu NKA modeli üçün proqram versiyalarının siyahısını əldə etmək mümkün olmadı",
      "cashRegisterModelVersionCheckSumsNotFound": "Bu proqram versiyası {{versionName}} üçün nəzarət məbləğlərinin siyahısını əldə etmək olmadı",
      "cashRegisterModelDocumentsNotFound": "Bu kassa modeli üzrə sənədlərin siyahısını əldə etmək mümkün olmadı",
      "waitingForSoftwareVersions": "Proqram təminatının versiyaları üzrə siyahının alınması...",
      "emptySoftwareVersionsList": "Bu model üzrə proqram təminatı versiyalarının siyahısı boşdur",
      "getStorePhotosFailed": "Obyektin fotolarını əldə etmək mümkün olmadı",
      "cashRegisterCategoryNotSet": " Attestasiya prosesini həyata keçirmək üçün NKA-nın kateqoriyasını təyin edin",
      "updateModelFailed": "NKA modelinin məlumatlarını yeniləmək mümkün olmadı",
      "getCashboxLocationsHistoryFailed": "NKA koordinatlarının dəyişmə tarixi üzrə məlumatları əldə etmək mümkün olmadı",
      "getCashboxTrackingDataFailed": "NKA koordinatlarında dəyişikliklərin izlənilməsi üzrə məlumatları əldə etmək mümkün olmadı",
      "failedToGetDocument": "Kassa çeki barədə məlumatları əldə etmək mümkün olmadı",
      "requestToUpdateDeviceCertificateFailed": "NMQ sertifikatının yenilənməsi üzrə sorğunu icra etmək mümkün olmadı",
      "certUpdateAlreadyInProgress": "Sorğu icra olunmadı. NMQ sertifikatının yenilənməsi üzrə bir öncəki sorğu icra prosesindədir",
      "requestToCreateCashBoxLogsFailed": "NKA loqlarının alınması üzrə sorğunu icra etmək mümkün olmadı",
      "cashBoxLogsRequestAlreadyInProgress": "Sorğu icra olunmadı. NKA loqlarının alınması üzrə bir öncəki sorğu icra prosesindədir",
      "firmwareUpdateAlreadyInProgress": "Sorğunu yerinə yetirmək mümkün olmadı. NMQ-nin proqram təminatının yenilənməsi üzrə bir öncəki sorğu icra olunur",
      "requestToUpdateDeviceFirmwareFailed": "NMQ-nin proqram təminatının yenilənməsi üzrə sorğunu yerinə yetirmək mümkün olmadı",
      "envInfoRequestAlreadyInProgress": "Sorğunu yerinə yetirmək mümkün olmadı. Sistem məlumatlarının əldə edilməsi üzrə bir öncəki sorğu icra olunur",
      "requestToGetEnvInfoFailed": "NKA-nın sistem məlumatları üzrə sorğusunu yerinə yetirmək mümkün olmadı",
      "requestInOffline": "Sorğu yalnız Onlayn rejimdə mümkündür",
      "blockCashBoxFailed": "NKA üzrə bloklanma sorğusu yerinə yetirilmədi",
      "unblockCashBoxFailed": "NKA-nın blokdan çıxarılması üzrə sorğu yerinə yetirilmədi",
      "removeBlockUnblockScheduleFailed": "Cədvəli silmək mümkün olmadı",
      "singleDateValidationHint": "Seçilmiş vaxt cari vaxtdan böyük olmalıdır",
      "datesPeriodValidationHint": "Dövrün yuxarı həddi aşağı həddən böyük olmalıdır",
      "changeCashBoxStatusFailed": "NKA-nın vəziyyətini dəyişdirmək sorğusu yerinə yetirilmədi",
      "fiscalDriverOperationForOldVersion": "Əməliyyat versiyası {{version}} başlayan fiskal sürücülər (drayverlər) üçün mümkündür",
      "taxpayerDataNotFound": "Vergi ödəyicisi barədə məlumatlar tapılmadı",
      "cashRegistersListReqFailed": "NKA siyahısı üzrə sorğu alınmadı",
      "cashRegisterNotFound": "\"{{searchText}}\" adlı NKA tapılmadı",
      "createInitOtpFailed": "OTP yaradılması uğursuz oldu"
    },
    "logsList": "Kassa loqları",
    "modelStatusHistory": "Modelinin vəziyyəti üzrə göstəricilər",
    "receiptAmountRangeSelectHint": "Növbənin bağlanması (Z-hesabat) və açılması çekləri istisna olmaqla",
    "requestLogs": "Loqları sorğula",
    "startAttestation": "Attestasiyanı başla",
    "storesRangeSelectHint": "Yalnız aktiv obyektlər",
    "turnoverForEntirePeriod": "Bütün dövr üzrə dövriyyə",
    "timeRange": "Çekin tarixi",
    "timeRangeTypes": {
      "QUICK_SELECT": "SÜRƏTLİ SEÇİM",
      "SHOW_DATES": "TARİX ARALIĞI",
      "COMMONLY_USED": "ƏN ÇOX İSTİFADƏ OLUNAN"
    },
    "hideFiltersPanel": "Filtr panelini gizlət",
    "confirmIgnoreFilters": "Filtrlər dəyişilib, lakin tətbiq olunmayıb. Filtrlər əvvəlki vəziyyətinə qaytarılacaq.",
    "donorHint": "Hazırkı NKA-nı qeydiyyata alaraq dəyişdirilən Nasaz NKA",
    "replacementsHint": "Hazırkı NKA-nın dəyişdirilməsi üçün qeydiyyata alınan NKA-lar",
    "deviceStatusHistory": "NMQ-nin vəziyyəti üzrə göstəricilər",
    "deviceFirmwareHistory": "NMQ-nin proqram təminatının versiyaları üzrə məlumatlar",
    "deviceRegisteredCashbox": "Qeydiyyata alınmış NKA üzrə məlumat",
    "deviceOperatorHistory": "Operatorlar üzrə məlumatlar",
    "deviceRegistrationHistory": "NMQ-də qeydiyyata alınmış NKA-lar üzrə məlumatlar",
    "coordinatesHistory": "Koordinatların dəyişdirilmə tarixi",
    "cashBoxesList": "Kassaların siyahısı",
    "cashBoxStatistics": "Kassalar üzrə statistikalar",
    "latitudeLongitude": "Enlik / Uzunluq",
    "doubleClickToSetCoordinates": "Xəritədə koordinatları təyin etmək üçün iki dəfə klikləyin",
    "modalMapDialogTitle": "Zəhmət olmasa xəritədə obyektin yerini iki dəfə klikləməklə göstərin",
    "initialCoordinates": "İlkin koordinatlar",
    "selectedCoordinates": "Seçilmiş koordinatlar",
    "deviceFirmwareUpdatesHistory": "NMQ-nin proqram versiyasının yenilənmə tarixi",
    "selectSuitableTargetVersion": "Uyğun versiyalar siyahısından hədəf olan versiyanı seçin",
    "currentCashboxLocation": "NKA-nın hazırki yerləşim nöqtəsi",
    "currentStoreLocation": "Obyektin yerləşim nöqtəsi",
    "selectedHistoryLocation": "NKA-nın seçilmiş tarixi yerləşim nöqtəsi",
    "viewControl": "Görüntünün idarəolunması",
    "historyLocation": "Tarix üzrə yerləşim nöqtəsi",
    "countOfCashboxesByMode": "NKA-ların sayı (rejim üzrə)",
    "countOfCashboxesByStatus": "NKA-ların sayı (vəziyyət üzrə)",
    "countOfCashboxesByType": "NKA-ların sayı (tip üzrə)",
    "countOfObjectsByStatus": "Obyektlərin sayı (vəziyyət üzrə)",
    "startReattestation": "Təkrar attestasiyanı başla",
    "completeReattestation": "Təkrar attestasiyanı bitir",
    "eliminateCashRegisterModel": "NKA modelini sil",
    "activateCashRegisterModel": "NKA modelini aktivləşdir",
    "attestationCompleted": "Attestasiya bitdi",
    "attestationNotCompleted": "Attestasiya yekunlaşmayıb. {{reason}}",
    "softwareVersionsHistory": "Proqram təminatının modelinin versiyası",
    "markVersionAsOutdated": "Versiyanı köhnəlmiş kimi qeyd et",
    "activateVersion": "Versiyanın aktivləşdirilməsi",
    "copyCheckSum": "Versiyanın nəzarət məbləğinin kopyalanması",
    "confirmActivateCashRegisterModel": "Siz həqiqətən bu NKA modelini aktivləşdirmək istəyirsiniz?",
    "confirmEliminateCashRegisterModel": "Bu NKA modelini silmək istəyirsiniz?",
    "confirmMarkVersionOutdated": "Bu proqram versiyasını köhnəlmiş kimi qeyd etmək istədiyinizə əminsiniz?",
    "confirmActivateVersion": "Siz həqiqətən proqram təminatının bu versiyasını aktivləşdirmək istəyirsiniz?",
    "markOutdated": "Köhnəlmiş kimi qeyd et",
    "selectSoftwareVersionForDocuments": "Sənədlər onlardan biri ilə əlaqəlidirsə, proqram təminatının versiyasını seçin",
    "checkSumHistory": "Nəzarət məbləğləri üzrə tarixi məlumatlar",
    "noDataForCheckSumHistory": "Nəzarət məbləğinin dəyişmə tarixi barədə məlumatlar yoxdur",
    "noDataForLocationsHistory": "NKA koordinatlarının dəyişmə tarixinin əks etdirilməsi üçün məlumatlar mövcud deyil",
    "noDataForTrackingHistory": "NKA koordinatlarında dəyişikliklərin izlənilməsi üçün məlumatlar mövcud deyil",
    "viewPictureDocument": "Kassa çekinin təsviri",
    "documentImage": "Kassa çekinin təsviri",
    "documentDetails": "Çek üzrə ətraflı məlumatlar",
    "relatedDocuments": "Bağlı olan çeklər",
    "documentIdentification": "Çekin identifikasiyası",
    "incorrectDocumentDateHint": "Formalaşdırılmış çek üzrə qeyri-korrekt tarix",
    "technicalTasks": "Servis və texniki göstəricilər",
    "deviceCertUpdatesHistory": "NMQ sertifikatının yenilənmə tarixi",
    "certificateUpdate": "NMQ sertifikatını yenilə",
    "requestsHistory": "Sorğular üzrə tarixi məlumatlar",
    "updateCertificate": "Sertifikatı yenilə",
    "refreshHistory": "Tarixi məlumatları yenidən yüklə",
    "certUpdateRequestCreated": "NMQ sertifikatının yenilənməsi üzrə sorğu yaradılmışdır",
    "logsRequestCreated": "NKA loqlarının alınması üzrə sorğu yaradılmışdır",
    "cashBoxLogsHistory": "NKA loqlarının sorğulanması üzrə tarixi məlumatlar",
    "firmwareUpdateRequestCreated": "NMQ-nin proqram təminatının yenilənməsi üzrə sorğu yaradılmışdır",
    "updateFirmware": "Proqram təminatının yenilənməsi",
    "firmwareUpdate": "NMQ-nın proqram təminatının yenilənməsi",
    "envInfoRequestCreated": "Sistem məlumatlarının alınması üzrə sorğu yaradılmışdır",
    "envInfoHistory": "Sistem məlumatların sorğulanma tarixi",
    "requestEnvInfo": "Məlumatın sorğulanması",
    "envInfoList": "Sistem məlumatları",
    "modelsListLimitationByOperatorHint": "Operatorun adı seçildiyi təqdirdə, qeyd olunan filterin seçimləri limitləşdirilir",
    "softwareVersionsLimitationByModelsHint": "Bu filtr üçün parametrlər seçilmiş kassa modelindən asılıdır",
    "cashRegisterModelStatistics": "Kassa modelləri üzrə statistika",
    "generalStatistics": "Ümumi statistika",
    "cashRegisterStatusHistory": "Kassa aparatının vəziyyəti üzrə göstəricilər"
  },
  "ReportsScreen": {
    "errors": {
      "failedLoadReportsList": "Hesabatların siyahısını yükləmək mümkün olmadı"
    },
    "reportPeriod": "Hesabat dövrü",
    "reportDate": "Hesabat üzrə tarix",
    "searchFilterItems": {
      "cashBoxTaxNumbers": "NMQ-nin qeydiyyat nömrəsi",
      "companyTaxNumbers": "VÖEN",
      "operatorTaxNumbers": "Operatorun VÖEN-i",
      "storeTaxNumbers": "Obyektin kodu"
    },
    "turnovers": {
      "correctionsCount": "Korreksiya: say",
      "correctionsSum": "Korreksiya: məbləğ",
      "moneybacksCount": "Geri qaytarma: say",
      "moneybacksSum": "Geri qaytarma: məbləğ",
      "rollbacksCount": "Ləğv etmə: say",
      "rollbacksSum": "Ləğv etmə: məbləğ",
      "salesCount": "Satış: say",
      "salesSum": "Satış: məbləğ"
    },
    "timeIsIgnored": "Bu filtrdəki vaxt hesabatda günlərə görə nəzərə alınmır",
    "byDay": "Günlər üzrə icmal hesabat",
    "byDayHint": "Hesabat günlər üzrə aqreqasiya olunaraq yüklənəcək"
  },
  "StatisticsScreen": {
    "goToCashboxesList": "NKA siyahısına keç"
  },
  "SystemScreens": {
    "addUser": "İstifadəçini əlavə et",
    "adminPanel": "İdarəetmə paneli",
    "backToMonitoring": "Monitorinq səhifəsinə qayıt",
    "basicInfo": "Əsas məlumatlar",
    "changePassword": "Şifrəni dəyişdir",
    "confirmBlockUser": "İstifadəçini bloklamaq istədiyinizə əminsinizmi?",
    "confirmDeleteUser": "İstifadəçini silmək istədiyinizə əminsinizmi?",
    "confirmUnblockUser": "İstifadəçini blokdan çıxarmaq istədiyinizə əminsinizmi?",
    "contactInfo": "Əlaqə məlumatları",
    "copyPassword": "Şifrəni kopyala",
    "currentPasswordNotShown": "Cari istifadəçi şifrəsi göstərilmir",
    "editEmail": "E-poçt ünvanını redaktə et",
    "editFirstName": "Adı redaktə et",
    "editLastName": "Soyadı redaktə et",
    "editMiddleName": "Ata adını redaktə et",
    "editPhone": "Telefon nömrəsini redaktə et",
    "editUser": "İstifadəçi məlumatlarını redaktə et",
    "errors": {
      "addUserFailed": "İstifadəçini əlavə etmək mümkün olmadı",
      "blockUserFailed": "İstifadəçini bloklamaq mümkün olmadı \"{{searchText}}\"",
      "changePasswordFailed": "İstifadəçi şifrəsini dəyişmək mümkün olmadı",
      "deleteUserFailed": "İstifadəçini silmək mümkün olmadı \"{{searchText}}\"",
      "emptyAccessRights": "İstifadəçinin giriş hüquqlarını seçin",
      "emptyFirstName": "Ad sətiri boş buraxılmamalıdır",
      "emptyLastName": "Soyad sətiri boş buraxılmamalıdır",
      "emptyPassword": "Şifrə sətiri boş buraxılmamalıdır",
      "incorrectUserRoles": "Əlavə rollar istifadəçinin əsas rolu ilə uyğun gəlmir",
      "invalidEmail": "Zəhmət olmasa düzgün olan e-poçt daxil edin",
      "invalidStoredPhone": "Əvvəllər saxlanmış {{phone}} nömrəsi yanlışdır. Yeni nömrə daxil edin",
      "invalidStoredPhoneContactAdministrator": "Saxlanmış telefon nömrəsi yanlışdır. Dəyişdirilməsi üçün administratora müraciət edin",
      "invalidPassword": "Şifrə yanlışdır",
      "phoneDoesNotMatchCountry": "Əvvəllər saxlanmış {{phone}} nömrəsi seçilmiş ölkəyə uyğun deyil. Yeni nömrə daxil edin",
      "phoneRequired": "Telefon nömrəsi mütləqdir",
      "passwordsNotSame": "Şifrələr fərqlidir",
      "unblockUserFailed": "İstifadəçini blokdan çıxarmaq mümkün olmadı  \"{{searchText}}\"",
      "updateUserInfoFailed": "İstifadəçi məlumatını yeniləmək mümkün olmadı",
      "userInfoNotFound": "İstifadəçi üzrə məlumatlar tapılmadı \"{{searchText}}\"",
      "usersNotFound": "İstifadəçilər tapılmadı",
      "passwordTooShort": "Şifrə ən azı {{minLength}} simvoldan ibarət olmalıdır",
      "emptyTaxAuthority": "Vergi orqanı sətri boş buraxıla bilməz",
      "passwordTooLong": "Şifrənin maksimal uzunluğu {{maxLength}} simvoldur",
      "passwordNotStrong": "Şifrə kifayət qədər güvənli deyil. Ən azı bir böyük hərf, bir kiçik hərf, bir rəqəm və bir xüsusi simvol istifadə edin",
      "passwordMinMaxLimits": "Şifrənin uzunluğu  {{minLength}} {{maxLength}}"
    },
    "generatePassword": "Şifrə yarat",
    "logoutOnChangePassword": "Şifrəni dəyişdirdiyiniz halda, sistemdən çıxacaqsınız",
    "newPassword": "Yeni şifrə",
    "oldPassword": "Köhnə şifrə",
    "otherInfo": "Digər məlumatlar",
    "retypeNewPassword": "Yeni şifrəni təkrar daxil et",
    "retypePassword": "Şifrəni təkrar daxil et",
    "removeStoredPhone": "Əvvəllər saxlanmış nömrəni sil",
    "selectTaxAuthority": "Vergi orqanını seç",
    "taxOfficer": "Vergi orqanının əməkdaşı",
    "userAdded": "İstifadəçi əlavə edildi",
    "userManagement": "İstifadəçinin idarə edilməsi",
    "ifOldPasswordIsForgotten": "Şifrəni unuttuğunuz zaman administratora müraciət etməyiniz xahiş olunur",
    "userProfile": "İstifadəçi profili"
  },
  "alert": {
    "alertCreationDate": "Alertin yaradılma  tarixi",
    "alertExecutionStatuses": {
      "FAILED": "İcra olunmayıb",
      "RUNNING": "İcra olunur",
      "SCHEDULED": "Planlaşdırılıb",
      "SUCCEED": "İcra olunub"
    },
    "alertStatuses": {
      "ALL": "Bütün",
      "CLOSED": "Bağlı",
      "IN_PROGRESS": "İcra olunur",
      "OPEN": "Açıq",
      "RESOLVED": "İcra olunub"
    },
    "alertType": "Alert növü",
    "alertTypes": {
      "CASH_BOX_CERTIFICATE_IS_EXPIRED_ALERT": "Sertifikat müddəti bitmiş NKA-lar",
      "CASH_BOX_WITHOUT_AUDIT_ALERT": "Texniki audit keçməyən NKA-lar",
      "CASH_BOX_WITH_FAILED_AUDIT_ALERT": "Sonuncu texniki autiditi uğursuz olan NKA-lar",
      "CASH_BOX_WITH_INVALID_TIME_ALERT": "Yanlış vaxtlı NKA-lar",
      "CREATION_DATE_IS_AFTER_THAN_INSERTION_DATE_ALERT": "Kassa çekləri üzrə real vaxt uyğunsuzluğu",
      "INVALID_DOCUMENT_REFERENCE_ALERT": "Mövcud olmayan kassa çeki üzrə geri qaytarma/ləğv etmə",
      "DOCUMENTS_CHAIN_GAP_ALERT": "Kassa çekləri üzrə kriptoqrafik zəncirin pozulması",
      "WRONG_VAT_PERCENT_ALERT": "Mövcud olmayan vergi faiz dərəcəsi həyata keçirilən kassa əməliyyatları",
      "INACTIVE_STORE_WITH_ACTIVE_CASH_BOX_ALERT": "Aktiv olmayan obyekt üzrə həyata keçirilən kassa əməliyyatları",
      "ACTIVE_STORE_WHERE_ALL_CASH_BOXES_BLOCKED_ALERT": "Aktiv olan obyektin kassaları bloklanıb",
      "ACTIVE_TAXPAYER_WITH_NO_ACTIVE_CASH_BOX_ALERT": "Aktiv olan vergi ödəyicisinin kassaları bloklanıb",
      "CLOSED_TAXPAYER_WITH_ACTIVE_CASH_BOX_ALERT": "Baglı vəziyyətində olan vergi ödəyicisi üzrə aktiv olan kassalar",
      "ACTIVE_CASH_BOX_WITHOUT_DOCS_ALERT": "45 gün ərzində kassa çek daxil etməyən aktiv kassalar barədə məlumatlar",
      "CASHBOX_WITH_INVALID_GPS_ALERT": "Qeyri-korrekt və movcud olmayan GPS koordinatlar üzrə kassaların siayhısı",
      "STORE_WITH_INVALID_GPS_ALERT": "Qeyri-korrekt və movcud olmayan koordinatlar üzrə obyektlərin siyahısı"
    },
    "assignee": "İçraçı",
    "priorities": {
      "MAJOR": "Yüksək",
      "MINOR": "Aşağı",
      "NORMAL": "Orta"
    },
    "prioritiesFull": {
      "MAJOR": "Yüksək prioritet",
      "MINOR": "Aşağı prioritet",
      "NORMAL": "Orta prioritet"
    },
    "priority": "Prioritet",
    "schedule": "Cədvəl",
    "alertRunDescription": "Göndərilən intervalda toplanmış məlumatlar bu alertin yoxlanılması üçün istifadə ediləcək",
    "runAlertTitle": "Yoxlama aparmaq"
  },
  "app": {
    "address": "Ünvan",
    "all": "Bütün",
    "cancel": "Ləğv et",
    "collapseAll": "Çevirmək",
    "comment": "Şərh",
    "copied": "Kopyalandı",
    "copy": "Kopyala",
    "data": "Məlumat",
    "date": "Tarix",
    "dateFrom": "Tarixdən",
    "dateTo": "Tarixədək",
    "dateTime": "Tarix / Vaxt",
    "delete": "Sil",
    "download": "Yüklə",
    "duration": "Müddət",
    "edit": "Redaktə et",
    "file": "Fayl",
    "filter": "Filtr",
    "filters": "Filtrlər",
    "from": "İlə",
    "hide": "Gizlət",
    "id": "ID",
    "link": "Link",
    "loading": "Yüklənir...",
    "mode": "Rejim",
    "name": "Ad",
    "note": "Qeyd",
    "of": "etibarən",
    "other": "Digər",
    "periods": {
      "currentMoment": "Cari gün ərzində",
      "currentMonth": "Cari ay ərzində",
      "currentYear": "Cari il ərzində",
      "forLast30Days": "Son 30 gün ərzində",
      "today": "Gün ərzində",
      "yesterday": "Dünən"
    },
    "periodsConsts": {
      "PREVIOUS_DAY": "Əvvəlki gün",
      "PREVIOUS_MONTH": "Əvvəlki ay",
      "PREVIOUS_WEEK": "Əvvəlki həftə"
    },
    "quantity": "Say",
    "save": "Yadda saxla",
    "settings": "Tənzimləmələr",
    "showCardView": "Kart görünüşünü göstər",
    "showTableView": "Cədvəl görünüşünü göstər",
    "status": "Vəziyyət",
    "sum": "Məbləğ",
    "time": "Vaxt",
    "timePeriodsShort": {
      "day": "gün",
      "hour": "saat",
      "minute": "dəqiqə",
      "month": "ay",
      "second": "saniyə",
      "year": "il"
    },
    "to": "Üzrə",
    "total": "Cəmi",
    "type": "Növ",
    "unhide": "Göstər",
    "periodsCommonlyUsed": {
      "today": "Bu gün",
      "yesterday": "Dünən",
      "thisWeek": "Cari həftə",
      "thisMonth": "Cari ay",
      "thisYear": "Cari il",
      "weekToDate": "Həftə",
      "monthToDate": "Ay",
      "yearToDate": "İl"
    },
    "last": "Son",
    "timeUnits": {
      "minutes": "dəqiqə",
      "hours": "saat",
      "days": "gün",
      "weeks": "həftə",
      "years": "il",
      "months": "aylar"
    },
    "ok": "OK",
    "doNotExist": "Mövcud deyil",
    "statuses": "Vəziyyəti",
    "noData": "Məlumat yoxdur",
    "preview": "Önizləmə",
    "yes": "Bəli",
    "no": "Xeyr",
    "show": "Göstərmək",
    "shown": " Göstərilir",
    "fileName": "Faylın adı",
    "management": "İdarəetmə",
    "close": "Bağla",
    "hints": {
      "partialSearchByOneUnable": "Tətbiq olunan parametr üzrə məlumat tapılmadı. Zəhmət olmasa parametri tam şəkildə daxil edin.",
      "partialSearchByOne": "Dəyərin bir hissəsinə görə axtarış yalnız bir element daxil edildikdə mümkündür.",
      "searchByList": "Tam siyahı üzrə axtarış üçün vergüllə ayrılmış tam dəyərlər göstərməlidir.",
      "searchByListUnable": "Siyahı üzrə axtarış mümkün deyil. Xahiş olunur, tək göstərici və ya onun bir hissəsini daxil edin.",
      "searchFieldLengthMoreThan": "Axtarış sətirinin uzunluğu {{number}} çox ola bilməz.",
      "enterValueHint": "Göstərici {{number}} simvoldan ibarət olmalıdır",
      "fieldCanNotBeEmpty": "Sətr boş buraxıla bilməz",
      "multipleValuesShallBeNumeric": "Dəyər yalnız rəqəmləri ehtiva edə bilər. Bir neçə dəyərin vergül ilə daxil edilməsi mümkündür.",
      "enterNumericValueHint": "Dəyər {{number}} rəqəmdən ibarət olmalıdır"
    },
    "filesDeleted": "Fayllar silinib",
    "confirmDeleteFile": "Faylı silmək istədiyinizə əminsiniz?",
    "confirmDeleteFiles": "Seçilmiş faylları silmək istədiyinizə əminsiniz?",
    "numberOfSelectedFiles": "Seçilmiş faylların sayı: {{number}}",
    "category": "Kateqoriya",
    "currentValue": "Cari göstərici",
    "targetValue": "Yeni göstərici",
    "selectTargetValue": "Yeni göstəricinin seçilməsi xahiş olunur",
    "enterTargetValue": "Yeni göstəricinin daxil edilməsi xahiş olunur",
    "selectInterval": "Zəhmət olmasa, vaxt intervalını seçin",
    "selectedFilters": "Seçilmiş filterlər",
    "apply": "Tətbiq et",
    "enterValue": "Göstəricini daxil edin",
    "reloadData": "Məlumatları yenidən yüklə",
    "fromForRange": "İlə",
    "toForRange": "Üzrə",
    "selected": "Secilib",
    "add": "Əlavə et",
    "downloadZipFile": "Zip faylı yüklə",
    "obsolete": "Köhnəlmiş",
    "search": "Axtarış",
    "clear": "Təmizlə",
    "scrollToTop": "Yuxarı sürüşdür",
    "scrollToBottom": "Aşağı sürüşdür",
    "increaseRowHeight": "Sətir hündürlüyünü artır",
    "decreaseRowHeight": "Sətir hündürlüyünü azalt"
  },
  "cashBox": {
    "audit": "Audit",
    "auditStatuses": {
      "failed": "Uğursuz oldu",
      "passed": "Uğurlu",
      "wasNotPerformed": "Audit aparılmayıb"
    },
    "blockAtTime": "Müəyyən bir vaxtdan",
    "blockScheduledOn": "Kilid planlaşdırılır",
    "cashboxRegistrationDate": "NKA-nin qeydiyyat tarixi",
    "cashboxState": "NKA-nın rejimi",
    "cashboxStates": {
      "OFFLINE": "Oflayn",
      "ONLINE": "Onlayn"
    },
    "cashboxStatus": "NKA-nın vəziyyəti",
    "cashboxStatuses": {
      "ACTIVE": "Active",
      "BLOCKED": "Blocked",
      "BROKEN": "Broken",
      "ELIMINATED": "Eliminated",
      "REGISTRATION": "Registration",
      "RESET": "Reset",
      "SERVICE": "Service"
    },
    "cashboxTaxNumber": "NMQ-nin qeydiyyat nömrəsi",
    "cashboxType": "NKA-nın növü",
    "cashboxTypes": {
      "PHYSICAL": "Fiziki",
      "SOFTWARE": "Proqram",
      "VIRTUAL": "Virtual",
      "ECOMM": "E-commerce"
    },
    "certificateExpireDate": "Sertifikatın bitmə tarixi",
    "cleanSchedule": "Aydın cədvəli",
    "clock": "Vaxt",
    "clockStatus": "NKA vaxtının düzgünlüyü",
    "clockStatuses": {
      "correct": "Düzgün",
      "deviated": "Yanlış"
    },
    "commentForCurrentStatus": "NKA-nın vəziyyətinə dair şərhlər",
    "commentOnBlocking": "Bloklama barədə şərh",
    "dateFromTo": "Müddəti təyin edin",
    "daysOffline": "Oflayn dövrü (günlər)",
    "expiredCertificate": "Sertifikat bitib",
    "invalidTime": "Yanlış vaxt ",
    "lastAuditDate": "Son texniki auditin keçirilmə tarixi",
    "lastDocDaysAgo": "Fəaliyyətsizlik dövrü (gün)",
    "registeredThisYear": "Cari il üzrə qeydiyyata alınıb",
    "pluralProps": {
      "active": "Aktiv",
      "blocked": "Bloklanmış",
      "inactive": "Passiv",
      "notBlocked": "Bloklanmamış",
      "primary": "Əsas",
      "temporary": "Müvəqqəti"
    },
    "replacement": "Əvəzetmə",
    "replacementTypes": {
      "primary": "Əsas",
      "temporary": "Müvəqqəti"
    },
    "timeDeviation": "Vaxt düzgünlüyü",
    "unblockAtTime": "Seçilmiş vaxtdan",
    "unblockComment": "Şərhin kilidini açın",
    "unblockingScheduled": "Kilidin açılması planlaşdırılır",
    "validTime": "Düzgün vaxt",
    "cashboxHierarchy": "NKA-ların iyerarxiyası",
    "cashboxHierarchyNotions": {
      "currentCashbox": "Hazırkı NKA",
      "childCashboxes": "Əvəzedici NKA-lar",
      "parentCashboxes": "Donor NKA-lar",
      "parent": "Donor",
      "children": "Əvəzedicilər",
      "child": "Əvəzedici",
      "parentCashbox": "Donor NKA"
    },
    "certificateExpireDateFilter": "Sertifikatın bitmə tarixi",
    "dateLastCoordinatesUpdate": "Koordinatların sonuncu yenilənmə tarixi",
    "gpsTracking": "GPS izləmə",
    "tracking": "İzləmə",
    "trackingAccuracy": "Dəqiqlik",
    "cashboxTaskStatuses": {
      "COMPLETED": "İcra olundu",
      "FAILED": "Xəta",
      "REJECTED": "İmtina oldundu",
      "CREATED": "Emal edilir ..."
    },
    "blockCashbox": "NKA-nın bloklanması",
    "unblockCashbox": "NKA-nın blokdan çıxarılması",
    "changeCashboxStatus": "NKA-nın vəziyyətinin dəyişdirilməsi",
    "certificateStatus": {
      "expired": "İstifadə müddəti bitib",
      "valid": "Etibarlıdır"
    }
  },
  "cashRegister": {
    "applicationArea": "İstifadə sahəsi",
    "attestationKey": "Attestasiya açarı",
    "cashRegisterFactoryNumber": "NKA-nın zavod nömrəsi",
    "agent": "Agent kassası",
    "dateTypeByModelStatuses": {
      "ACTIVE": "Reyestrə daxil edilmə tarixi",
      "ATTESTATION": "Attestasiyanın başlama tarixi",
      "ELIMINATED": "Reyestrdən çıxarılma tarixi",
      "REGISTRATION": "Qeydiyyat üçün müraciət tarixi",
      "REATTESTATION": "Sonuncu təkrar attestasiyanın tarixi"
    },
    "hardwareName": "Avadanlığın adı",
    "modelName": "Modelin adı",
    "modelStatus": "NKA modelinin vəziyyəti",
    "modelStatuses": {
      "ACTIVE": "Active",
      "ATTESTATION": "Attestation",
      "ELIMINATED": "Eliminated",
      "REGISTRATION": "Registration",
      "REATTESTATION": "Reattestation"
    },
    "pluralProps": {
      "active": "Active",
      "eliminated": "Eliminated"
    },
    "softwareName": "Proqram təminatının adı",
    "usage": "İstifadə",
    "usageItems": {
      "notUsed": "İstifadə olunmur",
      "used": "İstifadə olunur"
    },
    "attestationResult": "Attestasiyanın nəticələri",
    "attestationResults": {
      "ACCEPT": "Attestasiyaya başla",
      "REJECT": "Rədd et"
    },
    "attestationErrors": {
      "sevenDaysWarning": "Attestasiya prosesi ən azı 7 gün davam edir",
      "SEVEN_DAYS": "Attestasiya üzrə yeddi günlük müddət hələ başa çatmayıb",
      "WRONG_VERSION_NAME": "Seçilmiş versiya nömrəsi artıq istifadə olunur",
      "CHECKSUM_CHANGED": "Son 7 gün ərzində nəzarət məbləği dəyişdirilib",
      "FD_VERSION_CHANGED": "Son 7 gün ərzində fiskal sürücünün versiyası dəyişdirilib",
      "FD_VERSION_OUTDATED": "Köhnə versiyalı fiskal sürücü",
      "FW_VERSION_OUTDATED": "Köhnə versiyalı NMQ proqram təminatı"
    },
    "softwareVersionStatus": "Proqram təminatının versiyası haqqında məlumat",
    "softwareVersion": "Proqram təminatının versiyası",
    "softwareVersions": "PT versiyası (NKA)",
    "versionStatuses": {
      "ACTIVE": "Active",
      "ATTESTATION": "Attestasiya",
      "OUTDATED": "Köhnəlib",
      "ELIMINATED": "Silinib",
      "UNKNOWN": "Məlum deyil"
    },
    "reenterSoftwareVersion": "Dəyişmək istədiyiniz proqram təminatının versiyasını daxil edin",
    "os": "Əməliyyat sistemi",
    "cashRegisterCategory": "NKA-nın kateqoriyası",
    "cashRegisterTypes": {
      "agent": "Agent",
      "notAgent": "Adi",
      "portable": "Portativ",
      "stationary": "Stasionar"
    },
    "cashRegisterModelTaxNumber": "NKA modelinin qeydiyyat nömrəsi",
    "statuses": {
      "STOCK": "In stock",
      "READY": "Ready",
      "STORE": "On object",
      "ELIMINATED": "Ləğv edilib"
    },
    "registeredWithCashBox": "Kassa ilə qeydiyyatdan keçib",
    "cashRegisterModelsShort": "NKA-nın modelləri",
    "cashRegisterModelName": "Kassa aparatının model adı",
    "otpCode": "Bir dəfəlik şifrə",
    "generateOtpCode": "Bir dəfəlik şifrə yarat",
    "otpWarning": "Bir dəfəlik şifrəni kopyalayın və təhlükəsiz yerdə saxlayın. Bu pəncərəni bağladıqdan sonra kodu bərpa edə bilməyəcəksiniz.",
    "expiredAt": "Bir dəfəlik şifrə vaxtına qədər etibarlıdır: {{date}}",
    "modelTaxNumber": "NKA modelinin qeydiyyat nömrəsi"
  },
  "company": {
    "activity": "Fəaliyyət növü",
    "companyName": "Vergi ödəyicisinin adı",
    "companyStatus": "Vergi ödəyicisinin vəziyyəti",
    "companyStatuses": {
      "ACTIVE": "Aktiv",
      "CLOSED": "Bağlı ",
      "SUSPENDED": "Dayandırılıb"
    },
    "companyTaxNumber": "VÖEN",
    "taxpayerType": "Hüquqi statusu",
    "taxpayerTypes": {
      "LEGAL": "Hüquqi şəxs",
      "PHYSICAL": "Fiziki şəxs"
    }
  },
  "device": {
    "age": "Yaş",
    "deviceStatus": "NMQ-nin vəziyyəti",
    "deviceStatuses": {
      "BROKEN": "Broken",
      "PRODUCED": "Produced",
      "READY": "Ready",
      "RECYCLED": "Recycled",
      "SERVICE": "Service",
      "STOCK": "In stock",
      "STORE": "On object",
      "FIXED": "Fixed",
      "LOST": "Lost"
    },
    "deviceUSBType": "USB növü",
    "deviceUSBTypes": {
      "microB": "Mikro",
      "A": "Standart"
    },
    "fiscalDriverVersion": "Fiskal sürücünün versiyası",
    "wearout": "Кöhnəlmə",
    "workability": "Yararlılıq səviyyəsi",
    "workabilityLevels": {
      "INVALID": "Invalid",
      "JUNIOR": "Junior",
      "NEW": "New",
      "SENIOR": "Senior",
      "VETERAN": "Mature"
    },
    "experience": "Fəaliyyət dövrü",
    "firmware": "Proqram versiyası",
    "commentForCurrentStatus": "NMQ-nin vəziyyətinə dair qeydlər",
    "firmwarePlural": "PT versiyası",
    "deviceStatusGroups": {
      "taxOfficeStock": "Vergi xidmətinin qalığı",
      "operatorStock": "Operatorun qalığı",
      "onObject": "Təsərrüfat obyektində",
      "inService": "Servisdə",
      "outOfUse": "Dövriyyədən çıxarılıb"
    },
    "targetVersion": "Hədəf olan versiya",
    "resultVersion": "Quraşdırılmış versiya",
    "currentVersion": "Cari versiya",
    "firmwareVersion": "PT versiyası (NMQ)",
    "deviceFactoryNumber": "NMQ-nin zavod nömrəsi",
    "procCount": "Prosessorların sayı",
    "utcOffsetSec": "Yerli vaxtın UTC-yə nisbətən dəyişməsi (saniyə)",
    "ramSizeMB": "Operativ yaddaşın həcmi (Mb)",
    "productionID": "Partiyanın İD-si",
    "productionPlace": "Istehsal yeri",
    "productionDate": "İstehsalın başlama tarixi",
    "hardwareVersion": "Qurğunun versiyası",
    "production": "İstehsal",
    "fiscalDriver": "Fiskal sürücü",
    "dump": "Damp fayl",
    "repair": "Bərpa"
  },
  "document": {
    "KTM": "Ticarət əlavəsi",
    "carNumber": "Nəqliyyat vasitəsinin dövlət qeydiyyat nişanı",
    "cashier": "Kassir",
    "creditpayContractNumber": "Nisyə müqaviləsinin nömrəsi",
    "contractNumber": "Müqavilə nömrəsi",
    "creditPayerInfo": "Ödəyici barədə məlumatlar",
    "documentCreatedDate": "Çekin tarixi",
    "documentInsertedDate": "Kassa çekinin alınma tarixi",
    "documentType": "Kassa çekinin növü",
    "firstOperation": "Birinci əməliyyatın tarixi",
    "fiscalId": "Fiskal İD",
    "shortFiscalId": "Fiskal İD (qısa)",
    "lastDocument": "Sonuncu kassa çekinin",
    "lastDocumentDate": "Sonuncu kassa çekinin tarixi",
    "lastOperation": "Sonuncu əməliyyatın tarixi",
    "notTaxable": "ƏDV-dən azad",
    "paidInCash": "Ödənilib nağd",
    "parentFiscalIdLabels": {
      "correctionFiscalId": "Korreksiya çekinin Fiskal İD-si",
      "creditpayFiscalId": "Nisyə ödənişi çekinin Fiskal İD-si",
      "moneybackFiscalId": "Geri qaytarma çekinin Fiskal İD-si",
      "prepayFiscalId": "Avans (beh) ödənişi çekinin Fiskal İD-si",
      "prepayFiscalIds": "Avans (beh) ödəniş çekinin Fiskal İD-si",
      "saleFiscalId": "Satış çekinin Fiskal İD-si",
      "unknown": "Ana çekin Fiskal İD-si"
    },
    "parentFiscalId": "Valideyn fiskal ID",
    "paymentNumber": "Ödəniş üzrə ardıcıllıq nömrəsi",
    "paymentType": "Ödəniş növü",
    "paymentTypes": "Ödəniş növləri",
    "paymentTypesList": {
      "bonus": "Bonus",
      "cash": "Nağd",
      "cashless": "Nağdsız",
      "credit": "Nisyə",
      "prepayment": "Avans (beh)"
    },
    "positionInShift": "Növbə ərzində vurulmuş çek sayı",
    "price": "Qiymət",
    "productName": "Məhsulun adı",
    "productItems": "Mallar üzrə pozisiya",
    "receiptAmount": "Çekin məbləği",
    "residue": "Ödəniləcək qalıq məbləğ (borc)",
    "returnOfChange": "Qalıq qaytarılıb nağd",
    "sum": "Məbləğ",
    "tax": "Vergi",
    "taxRate": "Vergi dərəcəsi",
    "taxSum": "Vergi məbləği",
    "tel": "tel",
    "total": "Cəmi",
    "totalTax": "Toplam vergi",
    "type": {
      "Correction": "Korreksiya",
      "CreditPay": "Nisyə ödənişi",
      "MoneyBack": "Geri qaytarma",
      "OpenShift": "Növbənin açılması",
      "Prepayment": "Avans (beh) ödənişi",
      "RollBack": "Ləğv etmə",
      "Sale": "Satış",
      "ZReport": "Z-hesabat"
    },
    "typeForSelects": {
      "CORRECTION": "Korreksiya",
      "CREDITPAY": "Nisyə ödənişi",
      "MONEY_BACK": "Geri qaytarma",
      "OPEN_SHIFT": "Növbənin açılması",
      "PREPAY": "Avans (beh) ödənişi",
      "ROLLBACK": "Ləğv etmə",
      "SALE": "Satış",
      "Z_REPORT": "Z-hesabat"
    },
    "typeFullName": {
      "correctionDocument": "Korreksiya çeki",
      "creditpayDocument": "Nisyə ödənişi çeki",
      "moneybackDocument": "Geri qaytarma çeki",
      "openShiftDocument": "Növbənin açılması çeki",
      "prepayDocument": "Avans (beh) ödənişi çeki",
      "rollbackDocument": "Ləğv etmə çeki",
      "saleDocument": "Satış çeki",
      "saleDocumentCredit": "Satış (nisyə üzrə) çeki",
      "saleDocumentWithPrepay": "Satış (avans üzrə) çeki",
      "zReportDocument": "Növbənin bağlanması (Z-hesabat)"
    },
    "units": {
      "cubicMeters": "m³",
      "kilos": "kg",
      "liters": "litr",
      "meters": "m",
      "squareMeters": "m²",
      "things": "ədəd"
    },
    "measureUnit": "Ölçü vahidi",
    "zReport": {
      "correctionQuantity": "Korreksiya çeklərinin sayı",
      "correctionTotal": "Korreksiya məbləğinin cəmi",
      "creditQuantity": "Nisyə ödənişi çeklərinin sayı",
      "creditTotal": "Nisyə ödənişi məbləğinin cəmi",
      "firstPaymentDoc": "Birinci kassa çekinin№-si",
      "lastPaymentDoc": "Sonuncu kassa çekinin №-si",
      "moneyBackQuantity": "Geri qaytarma çeklərinin sayı",
      "moneyBackTotal": "Geri qaytarma məbləğinin cəmi",
      "numberOfDocumentsPerShift": "Növbə ərzində vurulmuş çek sayı",
      "numberOfUnsentDocuments": "DVX-ya göndərilməyən çeklərin sayı",
      "prepaymentQuantity": "Avans (beh) ödənişi çeklərinin sayı",
      "prepaymentTotal": "Avans (beh) ödənişi məbləğinin cəmi",
      "rollBackQuantity": "Ləğv etmə çeklərinin sayı",
      "rollBackTotal": "Ləğv etmə məbləğinin cəmi",
      "salesQuantity": "Satış çeklərinin sayı",
      "salesTotal": "Satış məbləğinin cəmi",
      "shiftClosedDate": "Növbənin bağlanması tarixi/vaxtı",
      "shiftOpenedDate": "Növbənin açılma tarixi/vaxtı",
      "turnoverTax": "Dövriyyə üzrə vergi"
    },
    "taxRates": {
      "0": "0%",
      "2": "2%",
      "8": "8%",
      "18": "18%",
      "OTHER": "Digər"
    },
    "taxRatesExcel": {
      "zero": "0%",
      "two": "2%",
      "eight": "8%",
      "eighteen": "18%",
      "other": "Digər"
    },
    "docNumber": "Kassa çekinin nömrəsi",
    "globalDocNumber": "Kassa çekinin qlobal nömrəsi",
    "parentDocDate": "Ana çekin tarixi",
    "parentDocSum": "Ana çekin məbləğ",
    "gasStation": "YDM üzrə məlumatlar",
    "gasStationInfo": {
      "fdp": "YPQ №",
      "pump": "Pompa №",
      "gun": "Tapanca №",
      "reservoir": "Çən №"
    },
    "agentInfo": "Aqent barədə məlumatlar",
    "committentInfo": {
      "tin": "Komitentin VÖEN-i",
      "name": "Komitentin adı",
      "agentContract": "Agent müqaviləsinin nömrəsi",
      "agentCommission": "Agentin komissiya faizi"
    },
    "itemAgentCommission": "Agentin komissiyası",
    "bonusCardNumber": "Bonus kartının nömrəsi",
    "retrievalReferenceNumber": "Banklararası tranzaksiya nömrəsi (RRN)",
    "guestsCount": "Qonaq sayı",
    "marginPrice": "Mal üzrə ticarət əlavəsi",
    "marginSum": "Ticarət əlavəsi üzrə məbləğ",
    "productCode": "Malın kodu",
    "productCodeType": "Mal kodunun növü",
    "productCodeTypes": {
      "GTIN": "GTIN",
      "ISBN": "ISBN",
      "ISSN": "ISSN",
      "EAN": "EAN",
      "DUNS": "DUNS"
    },
    "productCodeTypesTooltip": {
      "GTIN": "Qlobal Ticarət Elementi Nömrəsi",
      "ISBN": "Beynəlxalq Standart Kitab Nömrəsi",
      "ISSN": "Beynəlxalq Standart Serial Nömrəsi",
      "EAN": "Avropa Məhsul Nömrəsi",
      "DUNS": "Data Universal Nömrələmə Sistemi"
    },
    "markingCode": "Markalanma kodu",
    "documentVersion": "Kassa çekinin növü",
    "itemHash": "Mal adının xeş göstəricisi",
    "markingCodes": "Markalanma kodu",
    "paymentInfo": "Ödəniş üzrə məlumatlar",
    "operationInfo": "Əməliyyat üzrə məlumatlar",
    "openShiftOperationNumber": "Növbənin açılması əməliyyatı üzrə nömrə",
    "zReportOperationNumber": "Növbənin bağlanması əməliyyatı üzrə nömrə",
    "currencyReport": "Valyuta üzrə hesabat",
    "numberOfDocuments": "Çek sayı",
    "taxDetails": "Vergi üzrə ətraflı məlumatlar",
    "notTaxableSum": "ƏDV-dən azad olunan məbləğ",
    "creditPaymentSum": "Nisyə üzrə ödənişlərin məbləği",
    "approvalCode": "Təsdiq kodu",
    "interbankTransactions": "Banklararası tranzaksiya",
    "restoredDocument": "Çek NMQ-nin ehtiyat nüsxəsindən bərpa edildi",
    "restoredFromBackup": "NMQ-nin ehtiyat nüsxəsindən bərpa edildi",
    "restored": "Bərpa olunub",
    "paid": "Ödənilib"
  },
  "domain": {
    "accountMenu": "Hesab menyusu",
    "addListItem": "Siyahı elementi əlavə edin",
    "alert": "Alert",
    "alerts": "Alertlər",
    "block": "Blok",
    "cashRegister": "Proqram kassası",
    "cashRegisterModel": "NKA-nın modeli",
    "cashRegisterModels": "NKA-nın modelləri",
    "cashRegisters": "Proqram kassaları",
    "cashbox": "NKA",
    "cashboxes": "NKA-lar",
    "companies": "Vergi ödəyiciləri",
    "company": "Vergi ödəyicisi",
    "currency": "Valyuta",
    "device": "NMQ",
    "devices": "NMQ-lər",
    "document": "Kassa çeki",
    "documents": "Kassa çekləri",
    "elements": "Elementlər",
    "factoryNumber": "Zavod nömrəsi",
    "financial": "Maliyyə",
    "home": "Ana səhifə",
    "info": "Məlumat",
    "infographic": "İnfoqrafika",
    "legalAddress": "Hüquqi ünvan",
    "loadingData": "Məlumatların yüklənməsi...",
    "map": "Xəritə",
    "nowInSystem": "Hal-hazırda sistem üzrə",
    "operator": "Operator",
    "operators": "Operatorlar",
    "parameters": "Parametrlər",
    "period": "Dövr",
    "registrationDate": "Qeydiyyat tarixi",
    "registrationNumber": "Qeydiyyat nömrəsi",
    "registry": "Reyestr",
    "report": "Hesabat",
    "reports": "Hesabatlar",
    "retriesCount": "Cəhdlərin sayı",
    "rowsPerPage": "Hər səhifə üzrə sətir sayı",
    "searchBy": "Axtarış",
    "searchDocument": "Kassa çeki üzrə axtarış",
    "security": "Təhlükəsizlik",
    "select": "Seç",
    "showNew": "Yeniləri göstər",
    "start": "Başla",
    "statistics": "Statistika",
    "statusDate": "Vəziyyətin təyin olunma tarixi",
    "store": "Obyekt",
    "stores": "Obyektlər",
    "taxAuthority": "Vergi orqanı",
    "taxationType": "Mükəlləfiyyət",
    "taxationTypes": {
      "INCOME": "Gəlir vergisi",
      "PROFIT": "Mənfəət vergisi",
      "SIMPLIFIED": "Sadələşdirilmiş vergi ",
      "VAT": "ƏDV",
      "EMPTY": "Məlumat yoxdur"
    },
    "taxes": "Vergilər",
    "technical": "Texniki",
    "turnover": "Dövriyyə",
    "turnoverByActivity": "Fəaliyyət növləri üzrə dövriyyə",
    "turnovers": "Dövriyyələr",
    "unblock": "Blokdan çıxar",
    "update": "Yeniləmək",
    "user": "İstifadəçi",
    "users": "İstifadəçilər",
    "showNextPageReports": "Növbəti {{limit}} element",
    "showNextPageCashboxes": "Digər {{limit}} NKA-lar",
    "showNextPageDevices": "Növbəti {{limit}} NMQ-lər",
    "showNextPageDocuments": "Növbəti {{limit}} çeklər",
    "showNextPageTaxpayers": "Növbəti {{limit}} vergi ödəyiciləri",
    "deregistrationDate": "Qeydiyyatdan çıxarılma",
    "registration": "Qeydiyyat",
    "photos": "Fotolar",
    "upload": "Yükləmək",
    "dropZoneText": "Fotonu buraya dartın və ya seçmək üçün klikləyin",
    "dropZoneTitle": "Fotoların yüklənməsi",
    "maxNumberOfPhotos": "Fotoların maksimal sayı: {{numberOfFiles}}",
    "addPhotos": "Şəkillər əlavə edin",
    "inspection": "Yoxlama",
    "inspections": "Yoxlamalar",
    "dropZoneMaxFilesUploaded": "Maksimum sayda foto yüklənilmişdir",
    "setPhotoAsPreview": "Önizləmə fotosu kimi təyin et",
    "photoIsPreview": "Önizləmə fotosu",
    "deletePhoto": "Fotonu sil",
    "attachPhotos": "1-{{maxNumber}} foto yükləyin",
    "fileSizeAndFormats": "Faylın ölçüsü {{fileSize}} MB-dan çox olmamalıdır, mövcud formatlar {{formats}}",
    "showNextPageLocations": "Növbəti {{limit}} mövqelər",
    "locationData": "Yerləşim nöqtəsi barədə məlumatlar",
    "showNextPageStores": "Növbəti {{limit}} obyekt",
    "showNextPageOperators": "Növbəti {{limit}} operator",
    "result": "Nəticə",
    "activate": "Aktivləşdirmək",
    "eliminate": "Silmək",
    "dropZoneDocumentsText": "Sənədləri bura çekin və ya klikləyərək seçim edin",
    "attachDocuments": "Zəhmət olmasa {{maxNumber}} sənəd əlavə edin",
    "fileSizeAndFormatsDocuments": "Hər bir sənəd {{fileSize}} MB-dan çox olmamalı, mövcud formatlar {{formatlar}}",
    "dropZoneMaxDocumentsUploaded": "Sənədlərin maksimum sayı yüklənir",
    "addDocuments": "Sənədləri əlavə edin",
    "addedByUser": "İstifadəçi tərəfindən əlavə edilmişdir",
    "checkSum": "Nəzarət məbləği",
    "creationDate": "Yaradılma tarixi",
    "updatedDate": "Yenilənmə tarixi",
    "inactivity": "Fəaliyyətsizlik",
    "generalInfo": "Ümumi məlumatlar",
    "additionalInfo": "Əlavə məlumatlar",
    "country": "Ölkə",
    "code": "Kod",
    "requestDate": "Sorğu üzrə tarix",
    "statusDetails": "Status üzrə detallı məlumatlar",
    "statusChangeDate": "Vəziyyətin dəyişmə tarixi",
    "version": "Versiya",
    "architecture": "Arxitektura",
    "change": "Dəyişdirmək",
    "hints": {
      "incorrectStoreTaxNumber": "Obyekt kodunun formatı yanlışdır (10 rəqəm - 5(7) rəqəm).",
      "incorrectCompanyTaxNumber": "VÖEN-in formatı yanlışdır (10 rəqəm).",
      "incorrectCashboxTaxNumber": "Kassa qeydiyyat nömrəsinin formatı yanlışdır(10 simvol).",
      "incorrectRrn": "RRN-nin formatı yanlışdır (8-16 simvol)",
      "incorrectFiscalId": "Fiskal ID-nin formatı yanlışdır(42-46 baza58 simvol)."
    },
    "certificate": "Sertifikat",
    "registrationNumberShort": "Qeydiyyat nömrəsi",
    "service": "Servis",
    "initialization": "İnitializasiya",
    "addCashboxes": "NKA əlavə et",
    "operationStatus": "Əməliyyatın vəziyyəti",
    "maxNumberOfFiles": "Qəbul edilən fayl sayı: {{limit}}",
    "pictureSizeAndFormats": "Hər bir fotonun həcmi {{fileSize}} MB artıq olmamalıdır, mövcud formatlar {{formats}}",
    "devicesList": "NMQ-lərin siyahısı",
    "updateData": "Məlumatları yenilə",
    "logs": "Loqlar",
    "environment": "Mühit",
    "byDetailsLevel": "Detallaşdırma səviyyəsinə görə",
    "fiscalDriverPublicKey": "Fiskal sürücünün açıq açarı"
  },
  "errors": {
    "failedLoadList": "\"{{listName}}\" siyahısının yüklənmə xətası",
    "failedTryAgain": "İcra olunmadı, yenidən cəhd edin",
    "failedUploadFile": "Fayl yüklənmədi",
    "failedUploadFileName": "{{fileName}} adlı fayl yüklənmədi",
    "noResultsFound": "Sorğu üzrə heç bir nəticə tapılmadı",
    "notFoundByParams": "Tətbiq olunan parametrlər üzrə heç bir nəticə tapılmadı",
    "requestFailed": "Sorğu alınmadı",
    "somethingWrong": "Təəssüf ki, xəta baş verdi, yenidən cəhd edin",
    "toLessThanFrom": "Dəyər 'Üzrə' dəyər 'İlə'-dən az ola bilməz",
    "tokenNotReceived": "VÖ verifikasiya xətası",
    "failedUploadMaxFiles": "Faylı yükləmək mümkün deyil, faylı yükləmək mümkün deyil, icazə verilən maksimum fayl sayını yoxlayın",
    "commentNotEmpty": "Şərh sahəsi boş olmamalıdır",
    "commentLengthError": "Rəyin uzunluğu {{maxLength}} simvoldan artıq ola bilməz",
    "failedToGetUrl": "{{fileName}} adlı faylı yükləmək üçün URL əldə etmək mümkün olmamışdır",
    "failedToDeleteFiles": "Faylları silmək mümkün olmadı",
    "sameCurrentAndTargetValues": "Cari və yeni göstəricilər uyğundur",
    "noMeaningfulValue": "Uyğun məlumatları daxil edin."
  },
  "operator": {
    "operatorName": "Operatorun adı",
    "operatorTaxNumber": "Operatorun VÖEN-i",
    "operatorTaxNumberShort": "VÖEN",
    "serviceOperators": "Xidmət göstərən operatorlar"
  },
  "store": {
    "address": {
      "building": "Ev",
      "city": "Şəhər",
      "region": "Region",
      "street": "Küçə"
    },
    "storeAddress": "Obyektin ünvanı",
    "storeСategories": {
      "ADVERTISING": "REKLAM XİDMƏTLƏRİ",
      "CATERING": "İCTİMAİ İAŞƏ",
      "COMMUNICATION": "RABİTƏ",
      "EDUCATION": "TƏHSİL",
      "ENTERTAINMENT": "ƏYLƏNCƏ VƏ İSTRAHƏT XİDMƏTLƏRİ",
      "FINANCE": "MALİYYƏ",
      "GAS_STATION": "YANACAQ DOLDURMA MƏNTƏQƏSİ",
      "HEALTH_CARE": "SƏHİYYƏ",
      "HOTELS": "HOTEL",
      "OTHER": "DİGƏR",
      "PRODUCTION": "İSTEHSALAT VƏ MƏİŞƏT XİDMƏTLƏRİ",
      "PUBLIC_SERVICES": "ƏHALİYƏ XİDMƏTLƏR",
      "QUARRY": "KARXANA",
      "RENT": "İCARƏ",
      "TICKETS": "BİLET SATIŞI",
      "TRADE": "TİCARƏT FƏALİYYƏTİ"
    },
    "storeName": "Obyektin adı",
    "storeStatus": "Obyektin vəziyyəti",
    "storeStatuses": {
      "ACTIVE": "Aktiv",
      "CLOSED": "Bağlı",
      "ELIMINATED": "Ləğv edilib",
      "SUSPENDED": "Dayandırılıb"
    },
    "storeTaxAuthority": "Obyektin vergi orqanı",
    "storeTaxNumber": "Obyektin kodu",
    "storeTaxNumberShort": "Kodu",
    "storeType": "Təsnifat",
    "storeWebSite": "Veb səhifə",
    "storeTypes": {
      "ADVERTISING": "Reklam xi̇dmətləri̇",
      "AUTO_STATION": "Avtovağzal",
      "BANK": "Bank",
      "BEACH": "Çimərlik",
      "BEAUTY": "Bərbərxana və gözəllik salonları",
      "CAFE": "Kafe (yeməkxana)",
      "CAR_SERVICE": "Avtoservis xidmətləri",
      "CELEBRATIONS": "Şadlıq evi",
      "CEREMONIAL_SERVICES": "Mərasi̇m xi̇dmətləri̇",
      "COMMUNAL_SERVICES": "Mənzil təsərrüfatı obyektlərinin fəaliyyəti",
      "COMMUNICATION": "Rabi̇tə xi̇dmətiləri",
      "COMPUTERS": "Kompüterlə bağlı fəaliyyət",
      "CONSUMERS": "Məişət xidməti obyekti",
      "CULTURAL": "Mədəniyyət obyekti",
      "DENTIST": "Stomotoloq",
      "ENTERTAINMENT": "İstirahət və əyləncə obyekti",
      "EXCHANGE": "Valyuta dəyişmə məntəqəsi",
      "EXHIBITIONS": "Sərgi̇ salonu",
      "GAMING": "Həvəsləndi̇ri̇ci̇ oyunlar",
      "GAS_STATION": "Yanacaq doldurma məntəqəsi",
      "HEALTH_RESORT": "Sanatori̇ya-kurort",
      "HEALTH_SERVICES": "Səhi̇yyə xi̇dmətiləri",
      "HIGH_EDUCATION": "Ali təhsil ocağı",
      "HOSPITAL": "Sanatoriya, xəstəxana və ambulatoriya",
      "HOSTEL": "Yataqxana xidmətləri",
      "HOTELS": "Mehmanxana",
      "INSURANCE": "Sığorta",
      "INTRENET_CLUB": "İnternet klub",
      "LEGAL_SERVICES": "Notariat kontoru/ hüquqi xidmətlər",
      "MAGAZINES": "Qəzet və jurnalların satışı",
      "MANUFACTURING": "İstehsalat obyekti",
      "MARKET": "Bazar",
      "MOBILE_TRADE": "Səyyar ticarət",
      "MOTEL_CAMPING": "Motel/kempinq",
      "MOTEL_RESTAURANT": "Motel-restoran",
      "NUTRITION": "iİaşə",
      "OFFICES": "Ofis",
      "PARKING": "Avtomobil dayanacağı",
      "PAWNSHOP": "Lombard",
      "PAYMENT_TERMINALS": "Ödəniş terminalı",
      "PHARMACY": "Aptek və optika",
      "PHOTOS": "Fotoatelye",
      "PRESCHOOL": "Məktəbəqədər təhsil ocağı",
      "PUBLIC_CATERING": "İctimai iaşə",
      "PUBLISHING": "Qəzet nəşri̇",
      "QUARRY": "Karxana",
      "RENT": "İcarə",
      "RESTAURANTS": "Restoranlar",
      "RETAIL": "Pərakəndə ticarət",
      "SCHOOLS": "Məktəb və peşə məktəbi",
      "SPORT": "İdman sağlamlıq kompleksi",
      "STOCK": "Anbar",
      "TAXI": "Taksi xidmətləri",
      "TEAHOUSE": "Çay evi̇",
      "TICKETS": "Bi̇let satışı",
      "TOURISM": "Turi̇zm-ekskursi̇ya xidmətləri",
      "TRAININGS": "Hazırlıq kursları",
      "TRANSPORTATION": "Sərnişin və yük daşıma",
      "WASTE_RECEPTION": "Tulantıların qəbulu məntəqəsi̇",
      "WHOLESALE": "Topdan satış"
    },
    "storeMainActivities": {
      "TRADE": "TİCARƏT",
      "CATERING_SERVICES": "İAŞƏ XİDMƏTİ",
      "OTHER_SERVICES": "DİGƏR XİDMӘT",
      "PRODUCTION_FACILITY_NON_FOOD": "İSTEHSALAT OBYEKTİ (QEYRİ-ƏRZAQ)",
      "SPORTS_LEISURE_AND_ENTERTAINMENT_SERVICES": "İDMAN, İSTİRАHӘT VӘ ӘYLӘNCӘ XİDMӘTİ",
      "HEALTHCARE_SERVICES": "SӘHӘYYӘ XIDMӘTI",
      "HOUSEHOLD_SERVICES": "MӘIŞӘT XIDMӘTI",
      "PRODUCTION_FACILITY_FOOD": "İSTEHSALAT OBYEKTİ (ƏRZAQ)",
      "COMMUNICATION_SERVICES": "RABITӘ",
      "TRAVEL_SERVICES": "TURİZM XIDMӘTİ",
      "PRODUCTION_FACILITY_BEVERAGES": "İSTEHSAL OBYEKTİ (İÇKİ)",
      "PRODUCTION_FACILITY": "İSTEHSAL OBYEKTİ",
      "EDUCATION_SERVICES": "TӘHSİL XIDMӘTI",
      "TRANSPORTATION_SERVICES": "NӘQLİYYAT XIDMӘTI",
      "FINANCIAL_SERVICES": "MALİYYƏ XIDMӘTI"
    },
    "storeMiddleActivities": {
      "RETAIL_TRADE": "PƏRAKƏNDƏ TİCARƏT",
      "CAFE_RESTAURANT": "KAFE-RESTORAN",
      "RENTAL_FACILITY": "İCARƏ OBYEKTİ",
      "CELEBRATION_HOUSE": "ŞADLIQ EVI",
      "CAR_SERVICE": "AVTOSERVIS",
      "FACTORY": "ZAVOD",
      "WHOLESALE_TRADE": "TOPDAN TİCARƏT",
      "OFFICE": "OFIS",
      "TICKET_SALES": "BİLET SATIŞI",
      "LEISURE_AND_ENTERTAINMENT_CENTER": "İSTIRAHƏT VƏ ƏYLƏNCƏ OBYEKTİ",
      "HOSPITAL": "XƏSTƏXANA",
      "CULTURAL_OBJECT": "MƏDƏNİYYƏT OBYEKTİ",
      "SPORTS_CENTER": "İDMAN KOMPLEKSI",
      "TAILOR": "DƏRZİ",
      "WAREHOUSE": "ANBAR",
      "WATCH_REPAIRING": "SAAT TƏMİRİ",
      "CEREMONY_HOUSE": "MƏRASİM EVİ",
      "TELEVISION_AND_RADIO_BROADCASTING": "TELEVİZİYA VƏ RADİO YAYIMI",
      "HOTEL": "MEHMANXANA",
      "DENTISTRY": "STAMOTOLOGİYA",
      "HAIRDRESSERS_AND_BEAUTY_SALONS": "BƏRBƏRXANA VƏ GÖZƏLLIK SALONU",
      "DRY_CLEANING": "KİMYƏVİ TƏMİZLƏMƏ",
      "AGRICULTURE": "TƏSƏRRÜFAT",
      "SHOPPING_CENTER_MARKETPLACE": "TİCARƏT MƏRKƏZİ VƏ BAZAR",
      "FASHION_HOUSE_ATELIER": "MODA EVİ VƏ ATELYE",
      "POULTRY_AND_LIVESTOCK_FARMING": "QUŞLARIN VƏ HEYVANLARIN YETİŞDİRİLMƏSİ",
      "PHONE_REPAIR": "TELEFON TƏMİRİ",
      "TEAHOUSE": "ÇAY EVİ",
      "PRE_SCHOOL_EDUCATION": "MƏKTƏBƏQƏDƏR TƏHSIL",
      "MOBILE_COMMUNICATION_CUSTOMER_SERVICE": "MOBİL RABİTƏ ÜZRƏ MÜŞTƏRİ XİDMƏTİ",
      "BUS_STATION": "AVTOVAĞZAL",
      "TRAINING_COURSES": "HAZIRLIQ KURSU",
      "MOBILE_PHONE_REPAIR": "MOBİL TELEFON TƏMİRİ",
      "FURNITURE_REPAIR": "MEBEL TƏMİRİ",
      "SOCIAL_ASSISTANCE": "SOSİAL XİDMƏTLӘRİN GÖSTӘRİLMӘSİ",
      "MEDICAL_HEALTH_CARE_SERVICES": "HƏKİM-SANİTAR XİDMӘTİ",
      "LOMBARD": "LOMBARD",
      "EXHIBITION_HALL": "SƏRGİ SALONU",
      "LAUNDRY": "ÇAMAŞIRXANA",
      "CAR_PARKING": "AVTOMOBIL DAYANACAĞI",
      "FREIGHT_TRANSPORTATION_OFFICE": "YÜK DAŞIMA OFİSİ",
      "RECEPTION_POINT_FOR_METALS_AND_OTHER_WASTE": "METAL VƏ DİGƏR TULLANTILARININ QƏBULU MƏNTƏQӘSİ",
      "WEDDING_DRESS_RENTAL": "GƏLİNLİK PALTARLARININ KİRAYӘSİ",
      "ANIMAL_TRAINING_AND_CARE": "HEYVANLARIN TӘLIMI VӘ ONLARA QULLUQ",
      "COMPUTER_REPAIR": "KOMPÜTER TӘMIRИ",
      "COURIER_OR_DELIVERY_SERVICE": "KURYER VӘ YA ÇATDIRILMA XIDMӘTИ",
      "BOILER_REPAIR": "KOMBİ TӘMIRИ",
      "JEWELLERY_SERVICES": "ZӘRGӘRLİK XIDMӘTИ",
      "NOTARY_OFFICE_LEGAL_SERVICES": "NOTARIAT KONTORU HÜQUQ XIDMӘTLӘRI",
      "MEDICAL_CENTER": "TIBBI MӘRKӘZ",
      "TELECOMMUNICATION_ACTIVITIES": "TELEKOMMUNİKASİYA FƏALİYYƏTİ",
      "DECORATIVE_WORKS": "BƏZƏK İŞLƏRİ",
      "RENTAL_OF_SPORTS_AND_LEISURE_GOODS": "İDMAN VƏ İSTİRAHƏT ÜÇÜN NƏZƏRDƏ TUTULMUŞ MALLARIN İCARƏSİ",
      "PHOTO_STUDIO": "FOTO STUDİO",
      "CLOTHING_RENTAL": "DİGƏR PALTARLARIN KİRAYƏSİ",
      "COMPUTER_SERVICES": "KOMPÜTER XİDMƏTLƏRİ",
      "GLASS_WASTE_COLLECTION_POINT": "ŞÜŞƏ QƏBULU MƏNTƏQƏSİ",
      "INTERNET_SUPPLY_SERVICE": "İNTERNET TƏCHİZAT XİDMƏTİ",
      "GAMBLING": "HƏVƏSLƏNDİRİCİ OYUNLAR",
      "INTERNET_CLUB": "İNTERNET KLUB",
      "POST_OFFICE": "POÇT MƏRKƏZİ VƏ YA FİLİALI",
      "SHOE_REPAIR": "AYAQQABI TƏMİRİ",
      "PHOTO_PRINTING_SHOP": "SURƏTÇIXARMA OBYEKTİ",
      "DECORATION_OF_TRAYS": "XONÇALARIN BƏZƏDİLMƏSİ",
      "SANATORIUM": "SANATORİYA",
      "EYEGLASSES_REPAIR": "EYNƏKLƏRİN TƏMİRİ",
      "TOURIST_CAMPS_AND_RESORTS": "TURİST DÜŞƏRGƏLƏRİ VƏ TURBAZALAR",
      "CURRENCY_EXCHANGE_POINT": "VALYUTA DƏYİŞMƏ MƏNTƏQƏSİ",
      "VIDEO_COPYING_SERVICE": "VİDEOYAZILARIN SURƏTİNİN ÇIXARILMASI",
      "REPAIR_AND_PAINTING_OF_METAL_PRODUCTS": "METAL MƏMULATLARININ TƏMİRİ VƏ RƏNGLƏNMƏSİ",
      "DORMITORY": "YATAQXANA",
      "BICYCLE_REPAIR": "VELOSİPED TƏMİRİ",
      "CLEANING_SERVICE": "TƏMİZLƏMƏ XİDMӘTİ",
      "PASSENGER_TRANSPORTATION_OFFICE": "SƏRNİŞİN DAŞIMA OFİSİ",
      "KEY_MAKING_AND_REPAIR_SERVICE": "AÇARLARIN HAZIRLANMASI VƏ TƏMİRİ",
      "VEHICLE_AND_EQUIPMENT_REPAIR": "MAŞIN VӘ AVADANLIQLARIN TӘMİRİ",
      "RENTAL_OF_VIDEO_TAPES_AND_DISCS": "VİDEOLENTLӘRİN VӘ DİSKLӘRİN KİRAYӘSİ",
      "AIRPORT": "HAVA LİMANI",
      "MANAGEMENT_OF_APARTMENT_BUILDINGS": "ÇOXMƏNZİLLİ BİNALARIN İDARӘ OLUNMASI",
      "CLOTHING_REPAIR": "PALTARLARIN TӘMİRİ",
      "RESORT_AREA": "KURORT ZONA",
      "REPAIR_OF_HOUSEHOLD_APPLIANCES": "MƏİŞӘT AVADANLIQLARININ TӘMİRİ",
      "TOILET": "TUALET",
      "CARPET_CLEANING": "XALÇA YUMA",
      "WEDDING_CAR_DECORATION": "GƏLİN MAŞINLARININ BӘZӘDILMӘSİ",
      "TURNER": "TOKAR",
      "HIGHER_EDUCATION": "ALİ TӘHSIL",
      "POTTERY_TINWORK_AND_DISHWARE_PRODUCTION": "MİSGƏRLİK, QALAYÇILIQ VӘ SAXSI MӘMULATLARIN HAZIRLANMASI",
      "PUMP_REPAIR": "NASOS TӘMİRİ",
      "SCHOOL_VOCATIONAL_COLLEGE": "MӘKTӘB VӘ PEŞӘ MӘKTӘBİ",
      "TINWORKER": "TӘNӘKӘÇİ",
      "FINE_ARTS": "İNCƏSƏNӘT",
      "SHIP_REPAIR_AND_MAINTENANCE": "GӘMİLӘRİN TӘMİRİ VӘ ONLARA TEXNİKİ XİDMӘT"
    },
    "storeLowerActivities": {
      "SELLING_ALCOHOLIC_BEVERAGES": "ALKOQOLLU İÇKİLƏRİN SATIŞI",
      "SELLING_WATCHES": "SAATLARIN SATIŞI",
      "RESTAURANT": "RESTORAN",
      "RENTAL_FACILITY": "İCARƏ OBYEKTİ",
      "FUEL_SELLING": "YANACAĞIN SATIŞI",
      "SELLING_PETROLEUM_PRODUCTS": "NEFT MƏHSULLARININ SATIŞI",
      "FUEL_FILLING_POINTS": "YANACAQ DOLDURMA MƏNTƏQƏLƏRİ",
      "CELEBRATION_HOUSE": "ŞADLIQ EVI",
      "FOODS_SELLING": "ƏRZAQ MALLARININ SATIŞI",
      "MARKET_NETWORK_FOOD": "MARKETLƏR ŞƏBƏKƏSİ (ƏRZAQ)",
      "CAR_SERVICE": "AVTO SERVİS",
      "SELLING_WOMEN_CLOTHING": "QADIN GEYİMLƏRİNİN SATIŞI",
      "FURNITURE_MANUFACTURING": "MEBEL İSTEHSALI",
      "GAS_FILLING_POINTS": "QAZ DOLDURMA MƏNTƏQƏLƏRİ",
      "SELLING_TOBACCO_PRODUCTS": "TÜTÜN MƏMULATLARININ SATIŞI",
      "SECURITY_SERVICE": "MÜHAFİZƏ XİDMƏTİ",
      "SELLING_BIJOUTERIE_AND_ACCESSORIES": "BIJUTERİYALARIN SATIŞI",
      "SELLING_STATIONERY_SUPPLIES": "DƏFTƏRXANA LƏVAZİMATLARININ SATIŞI",
      "AIR_TICKET_OFFICE": "AVİAKASSA",
      "SELLING_MOBILE_PHONES": "MOBİL TELEFONLARIN SATIŞI",
      "SELLING_COSMETICS_AND_PERFUMERY": "KOSMETİKA VƏ ƏTRİYYAT MALLARININ SATIŞI",
      "SELLING_CHILDREN_CLOTHING": "UŞAQ GEYİMLƏRİNİN SATIŞI",
      "SELLING_HOUSEHOLD_GOODS": "TƏSƏRRÜFAT MALLARININ SATIŞI",
      "PLANTS_SELLING": "BİTKİLƏRİN SATIŞI",
      "SELLING_SUGAR_CHOCOLATE_AND_CONFECTIONERY": "ŞƏKƏR, ŞOKOLAD VƏ QƏNNADI MƏMULATLARININ SATIŞI",
      "FOOTWEAR_SELLING": "AYAQQABI SATIŞI",
      "BOOKS_SELLING": "KİTABLARIN SATIŞI",
      "GAMES_ROOM": "OYUN ZALI",
      "KITCHENWARE_SELLING": "QAB-QACAQLARIN SATIŞI",
      "CAR_SELLING": "AVTOMOBİLLƏRİN SATIŞI",
      "SOUVENIR_MANUFACTURING": "SUVENİR İSTEHSALI",
      "COFFEE_HOUSE": "KOFE EVİ",
      "FURNITURE_SELLING": "MEBELLƏRİN SATIŞI",
      "SELLING_SILVER_AND_OTHER_METAL_JEWELLERY": "GÜMÜŞ VƏ DİGƏR ZİNƏT ƏŞYALARININ SATIŞI",
      "CAFE": "KAFE",
      "MAIL_OR_INTERNET_SALES": "POÇT VƏ YA İNTERNET İLƏ SATIŞ",
      "CLINIC": "KLİNİKA",
      "CINEMA": "KİNOTEATR",
      "SELLING_MEAT_AND_MEAT_PRODUCTS": "ƏT VƏ ƏT MƏHSULLARININ SATIŞI",
      "SPORTS_HALL": "İDMAN ZALI",
      "SELLING_HUNTING_SUPPLIES": "OVÇULUQ LƏVAZİMATLARININ SATIŞI",
      "SELLING_SWEETS": "ŞİRNİYYATIN SATIŞI",
      "TAILOR": "DƏRZİ",
      "SELLING_ELECTRICAL_HOUSEHOLD_GOODS": "ELEKTRİK-MƏİŞƏT MALLARININ SATIŞI",
      "CANTEEN": "YEMӘKXANA",
      "SELLING_COMPUTERS": "KOMPÜTERLƏRİN SATIŞI",
      "STORAGE_AND_WAREHOUSING_SERVICES": "SAXLAMA VƏ ANBARLARA YIĞMA",
      "ENTERTAINMENT_CENTER": "ӘYLӘNCӘ MӘRKӘZİ",
      "PRODUCTION_OF_SAUSAGES": "KOLBASA İSTEHSALI",
      "LUMINAIRE_SELLING": "ÇİL-ÇIRAQLARIN SATIŞI",
      "CONFECTIONERY_PRODUCTION": "ŞİRNİYYAT İSTEHSALI",
      "SELLING_INDUSTRIAL_GOODS": "SӘNAYE MALLARININ SATIŞI",
      "SELLING_CONSTRUCTION_MATERIALS": "TİKİNTİ MATERİALLARININ SATIŞI",
      "TABLEWARE_SELLING": "TAMETLӘRİN SATIŞI",
      "SELLING_SPORTS_GOODS": "İDMAN MALLARININ SATIŞI",
      "SELLING_CHEMICALS": "KİMYӘVİ MӘHSULLARIN SATIŞI",
      "SELLING_CAR_SPARE_PARTS": "AVTOMOBIL EHTİYAT HİSSӘLӘRİNİN SATIŞI",
      "SELLING_PHARMACEUTICAL_GOODS": "ӘCZAÇILIQ MALLARININ SATIŞI",
      "FISH_RESTAURANT": "BALIQ EVİ",
      "JEWELLERY_SELLING": "ZӘRGӘRLİK MӘMULATLARININ SATIŞI",
      "RETAIL_TRADE_OF_FERTILIZERS_SEEDS_AND_PESTICIDES": "GÜBRӘ, TOXUM VӘ PESTİSİDLӘRİN PӘRAKӘNDӘ SATIŞI",
      "GIFTS_SELLING": "HӘDİYYӘLӘRİN SATIŞI",
      "WATCH_REPAIRING": "SAAT TӘMİRİ",
      "SELLING_ANIMALS": "DİRİ HEYVANLARIN SATIŞI",
      "BEER_HALL": "PİVӘ EVİ",
      "CEREMONY_HOUSE": "MӘRASİM EVİ",
      "SELLING_DAIRY_PRODUCTS": "SÜD MӘHSULLARININ SATIŞI",
      "SELLING_OPTICAL_GOODS": "OPTİK MALLARIN SATIŞI",
      "TRANSLATION_SERVICES": "TRANSLASİYA",
      "BREAD_PRODUCTION": "ÇÖRӘK İSTEHSALI",
      "PLASTICS_MANUFACTURING": "PLASTİK MӘMULATLARIN İSTEHSALI",
      "HOTEL": "OTEL",
      "SELLING_VETERINARY_GOODS": "BAYTARLIQ MӘMULATLARININ SATIŞI",
      "PIZZA_SHOP": "PİZZA",
      "SELLING_ANIMAL_FEED": "HEYVANLAR ÜÇÜN YEMLӘRİN SATIŞI",
      "MOTEL": "MOTEL",
      "DENTAL_CLINIC": "STOMATOLOJİ KLİNİKA",
      "SELLING_CERAMICS_TILES": "KAFEL-METLAX SATIŞI",
      "PRODUCTION_OF_PLASTIC_DOORS_AND_WINDOWS": "PLASTİK QAPI-PƏNCƏRƏ İSTEHSALI",
      "WOMEN_BEAUTY_SALON": "QADIN GÖZƏLLİK SALONU",
      "SELLING_CURTAINS": "PƏRDƏ-TÜLLƏRİN SATIŞI",
      "PRODUCTION_OF_OTHER_MACHINERY_AND_TOOLS": "SAİR MAŞIN, DƏZGAH VӘ AVADANLIQLARIN İSTEHSALI",
      "PUBLIC_ADMINISTRATIVE_BUILDING": "QEYRİ-DÖVLƏT İNZİBATİ BİNASI",
      "TOUR_OPERATOR": "TUR OPERATOR",
      "DENTAL_OFFICE": "STOMATOLOJİ KABİNET",
      "PRODUCTION_OF_ALCOHOLIC_BEVERAGES": "SPİRTLİ İÇKİ İSTEHSALI",
      "SELLING_HEATING_SYSTEMS": "İSTİLİK SİSTEMLƏRİNİN SATIŞI",
      "REFRACTORY_MATERIALS_MANUFACTURING": "ODADAVAMLI MƏMULATLARIN İSTEHSALI",
      "DRY_CLEANING_SERVICES": "KİMYƏVİ TƏMİZLƏMƏ",
      "GROWING_OTHER_PLANTS": "DIGƏR BİTKİLƏRİN BECƏRİLMƏSİ",
      "SELLING_TEXTILE_MATERIALS": "TOXUCULUQ MƏMULATLARININ SATIŞI",
      "SELLING_FLOUR_AND_FLOUR_PRODUCTS": "UN, UN MƏMULATLARININ SATIŞI",
      "PRODUCTION_OF_RUBBER_TYRES_TUBES_AND_PIPES": "REZİN ŞİN, TƏKƏR VƏ KAMERALARIN İSTEHSALI",
      "PRODUCTION_OF_OTHER_CONCRETE_PRODUCTS": "BETON, GİPS VƏ SEMENTDƏN SAİR MƏMULATLARIN İSTEHSALI",
      "SOUVENIRS_SELLING": "SUVENİRLƏRİN SATIŞI",
      "BAGS_SELLING": "ÇANTALARIN SATIŞI",
      "BAR": "BAR",
      "MEN_BARBER_SHOP": "KİŞİ BƏRBƏR SALONU",
      "SHOPPING_CENTER": "TİCARƏT MƏRKƏZİ",
      "FASHION_HOUSE_ATELIER": "MODA EVİ VƏ ATELYE",
      "PLUMBING_EQUIPMENT_INSTALLATION_SERVICES": "SU KƏMƏRİ SİSTEMİ VƏ SANİTAR TEXNİKİ AVADANLIQLARIN QURAŞDIRILMASI ÜZRƏ XİDMƏTLƏR",
      "SELLING_STYROFOAM": "PENOPLASTIN SATIŞI",
      "POULTRY_FARMING": "EV (KƏND TƏSƏRRÜFATI) QUŞLARININ YETİŞDİRİLMƏSİ",
      "PRODUCTION_OF_MILK_AND_DAIRY_PRODUCTS": "SÜD VƏ SÜD MƏHSULLARININ İSTEHSALI",
      "PHONE_REPAIR": "TELEFON TƏMİRİ",
      "SELLING_EQUIPMENT_FOR_MINING_AND_CONSTRUCTION": "DAĞ-MƏDӘN VӘ TİKİNTİ İŞLӘRİ ÜÇÜN MAŞIN VӘ AVADANLIQLARIN SATIŞI",
      "TEAHOUSE": "ÇAY EVİ",
      "TOYS_SELLING": "OYUNCAQLARIN SATIŞI",
      "MANUFACTURING_OF_OTHER_FINISHED_METAL_PRODUCTS": "SAİR HAZIR METAL MӘMULATLARININ İSTEHSALI",
      "PET_SHOP": "ZOO MAĞAZA",
      "ADVERTISING_SERVICE": "REKLAM XİDMӘTİ",
      "POLYCLINIC": "POLİKLİNİKA",
      "MANUFACTURING_OF_OTHER_FOOD_PRODUCTS": "DIGӘR QRUPLARA DAXİL EDİLMӘYӘN SAİR QİDA MӘHSULLARININ İSTEHSALI",
      "SELLING_SCHOOL_SUPPLIES": "MƏKTӘB LӘVAZİMATLARININ SATIŞI",
      "PARK": "PARK",
      "TOUR_AGENT": "TUR AGENT",
      "SELLING_OTHER_MACHINES_AND_EQUIPMENT": "SAİR MAŞIN VӘ AVADANLIQLARIN SATIŞI",
      "SELLING_AGRICULTURAL_MACHINES_AND_EQUIPMENT": "KӘND TӘSӘRRÜFATI MAŞINLARININ VӘ AVADANLIQLARININ SATIŞI",
      "PRODUCTION_OF_OTHER_NON_FOOD_PRODUCTS": "DIGӘR QEYRİ-QİDA MӘHSULLARININ İSTEHSALI",
      "PRODUCTION_OF_FLOUR_MILLING_INDUSTRY_PRODUCTS": "BUĞDA EMALI SӘNAYESI MӘHSULLARININ İSTEHSALI",
      "PRODUCTION_OF_MEN_CLOTHING": "KİŞİ GEYİMİ İSTEHSALI",
      "PRODUCTION_OF_COMBI_RADIATORS": "KOMBİ RADİATORLARININ İSTEHSALI",
      "CATERING_SERVICE": "KEYTRİNQ",
      "SELLING_ROOF_COVERINGS": "DAM ÖRTÜKLӘRİNİN SATIŞI",
      "BEACH": "ÇİMӘRLİK",
      "TANDOOR_OVEN": "TƏNDİR",
      "REPAIR_OF_OTHER_PRODUCTS_EQUIPMENT_AIRCRAFTS": "DIGӘR MӘMULATLARIN, AVADANLIQLARIN, UÇUŞ APARATLARININ TӘMİRİ",
      "SELLING_SANITARY_GOODS": "SANTEXNİKA MALLARININ SATIŞI",
      "FLOUR_PRODUCTION": "UN İSTEHSALI",
      "SELLING_MEDICAL_AND_ORTHOPAEDIC_GOODS": "TİBB VӘ ORTOPEDİK MALLARININ SATIŞI",
      "SPA_SALON": "SPA SALONU",
      "HAZELNUT_PROCESSING": "FINDIĞIN EMALI",
      "GYM_FITNESS_HALL": "TRENAJOR (FİTNES) ZALI",
      "NEWSPAPER_STAND": "QƏZET KÖŞKÜ",
      "FOOTBALL_FIELD": "FUTBOL MEYDANÇASI",
      "SELLING_OTHER_PHONES": "DIGӘR TELEFONLARIN SATIŞI",
      "PRODUCTION_OF_PILLOWS_MATTRESSES": "YASTIQ, DÖŞӘK VӘ S. BU KİMİ OXŞAR MALLARIN İSTEHSALI",
      "PRODUCTION_OF_PLASTIC_BAGS": "POLİETİLEN PAKETLӘRİN İSTEHSALI",
      "PRODUCTION_OF_CHEMICAL_PRODUCTS": "KİMYӘVİ MӘHSULLARIN İSTEHSALI",
      "LIMESTONE_AND_GYPSUM_MINING": "ӘHӘNG DAŞININ VƏ GİPSİN HASİLATI",
      "SELLING_FLOWERS": "GÜLLӘRİN SATIŞI",
      "PRODUCTION_OF_MARBLE": "MӘRMӘR İSTEHSALI",
      "PRODUCTION_OF_PACKAGING_FROM_OTHER_MATERIALS": "DIGӘR MATERİALLARDAN TARALARIN (YEŞIKLӘRİN) İSTEHSALI",
      "CARPETS_SELLING": "XALÇALARIN SATIŞI",
      "SELLING_AUDIO_AND_VIDEO_EQUIPMENT": "AUDİO VӘ VİDEO AVADANLIQLARIN SATIŞI",
      "INSTALLATION_ELECTRIC_HEATING_SYSTEMS": "ELEKTRİK İSTİLİK SİSTEMLƏRİNİN QURAŞDIRILMASI ÜZRƏ XİDMƏTLƏR",
      "SELLING_TELECOMMUNICATION_EQUIPMENT": "TELEKOMUNİKASİYA AVADANLIQLARININ SATIŞI",
      "GLASS_SELLING": "ŞÜŞƏNİN SATIŞI",
      "FODDER_PRODUCTION": "YEM İSTEHSALI",
      "RETAIL_SELLING_NON_ALCOHOLIC_BEVERAGES": "ALKOQOLSUZ İÇKİLƏRİN PƏRAKƏNDƏ SATIŞI",
      "WALLPAPER_SELLING": "DİVAR KAĞIZLARININ SATIŞI",
      "PRODUCTION_OF_PARQUET_FLOORING": "PARKET DÖŞƏMƏLƏRİN İSTEHSALI",
      "KINDERGARTEN": "UŞAQ BAĞÇASI",
      "CAR_MARKET": "MAŞIN BAZARI",
      "SELLING_WOODEN_MATERIALS": "TAXTA MATERİALLARININ SATIŞI",
      "MOBILE_COMMUNICATION_CUSTOMER_SERVICE": "MOBİL RABİTƏ ÜZRƏ MÜŞTƏRİ XİDMƏTİ",
      "SELLING_FERTILISERS_AND_AGROCHEMICAL_PRODUCTS": "GÜBRƏ VƏ AQROKİMYƏVİ MƏHSULLARIN SATIŞI",
      "OPERATION_OF_BUS_STATIONS": "AVTOVAĞZALLARIN FƏALİYYƏTİ",
      "TRAINING_CENTER": "TƏDRİS MƏRKƏZİ",
      "SURGERY_ROOM": "DÖNƏRXANA",
      "ICE_CREAM_PRODUCTION": "DONDURMA İSTEHSALI",
      "SELLING_NUTRITIONAL_SUPPLEMENTS": "QİDA ƏLAVƏLƏRİNİN SATIŞI",
      "METAL_PROCESSING_AND_COATING": "METALLARIN EMALI VƏ METALLARA ÖRTÜK ÇƏKİLMƏSİ",
      "PRODUCTION_OF_CRACKERS_AND_COOKIES": "SUXARI VƏ PEÇENYE İSTEHSALI",
      "PAPER_AND_CARDBOARD_PRODUCTION": "KAĞIZ VƏ KARTON İSTEHSALI",
      "MANUFACTURING_OF_CONFECTIONERY_FROM_SUGAR": "ŞƏKƏRDƏN QƏNNADI MƏMULATLARININ İSTEHSALI",
      "CUSTOMS_WAREHOUSES_STORAGES_FREE_WAREHOUSES": "GÖMRÜK ANBARLARININ, MÜVƏQQƏTİ SAXLANC ANBARLARININ, SƏRBƏST ANBARLARIN TƏSİS EDİLMӘSİ",
      "FOOTWEAR_PRODUCTION": "AYAQQABI İSTEHSALI",
      "SELLING_PAINT_AND_VARNISH_MATERIALS": "LAK-BOYA MADDƏLӘRİNİN SATIŞI",
      "GREENHOUSE": "İSTİXANA",
      "INSTALLATION_HEATING_VENTILATION_AIR_CONDITIONING_SYSTEMS": "İSTİLİK, VENTİLYASİYA, SOYUTMA TӘCHİZATI SİSTEMLӘRİNİN QURAŞDIRILMASI ÜZRӘ XİDMӘTLӘR",
      "CATTLE_BREEDING": "İRİ BUYNUZLİ MAL-QARANIN YETİŞDİRİLMӘSİ",
      "FRUIT_AND_VEGETABLES_SELLING": "MEYVӘ VӘ TӘRӘVӘZİN SATIŞI",
      "PRODUCTION_OF_NON_ALCOHOLIC_BEVERAGES": "ALKOQOLSUZ İÇKİLӘRİN İSTEHSALI",
      "SUGAR_PRODUCTION": "QӘND İSTEHSALI",
      "MEDICAL_OFFICE": "TİBBİ KABİNET",
      "PRODUCTION_OF_MEAT_PRODUCTS": "ӘT MӘHSULLARININ İSTEHSALI",
      "MOBILE_PHONE_REPAIR": "MOBİL TELEFON TƏMİRİ",
      "FURNITURE_REPAIR": "MEBEL TӘMİRİ",
      "BATHHOUSE": "HAMAM",
      "CAKE_PRODUCTION": "TORT İSTEHSALI",
      "SELLING_METAL_AND_METAL_PRODUCTS": "METAL VӘ METAL MӘMULATLARIN SATIŞI",
      "PRINTING_HOUSE": "MӘTBӘӘ",
      "TIRE_SERVICE": "TӘKӘR TӘMİRİ",
      "CARE_FOR_PERSONS_WITH_ALCOHOL_AND_DRUG_ABUSE_PROBLEMS": "ƏQLİ İNKİŞAFDAN QALAN ŞӘXSLӘR ALKOQOL VӘ NARKOTİKLӘRDӘN SUİ-İSTİFADӘ EDӘN PSİXİKİ POZULMALARI VӘ YA FİZİKİ ÇATIŞMAMAZLIQLARI OLAN ŞӘXSLӘRӘ QULLUQ",
      "MEDICAL_HEALTH_CARE_SERVICES": "HӘKİM-SANİTAR XİDMӘTİ",
      "PRODUCTION_OF_PAINT_SUBSTANCES_AND_PIGMENTS": "BOYAQ MADDӘLӘRİ VӘ PİQMENTLӘRİN İSTEHSALI",
      "SELLING_FLOUR": "UN SATIŞI",
      "COSMETOLOGY_CENTER": "KOSMETOLOLİ MӘRKӘZ",
      "BROADCASTING_ACTIVITY": "TRANSLYASİYA FӘALİYYӘTİ",
      "CONSTRUCTION_OF_BUILDINGS": "YAŞAYIŞ VӘ QEYRİ-YAŞAYIŞ BİNALARININ TIKINTISI",
      "AESTHETIC_MEDICINE_CENTER": "ESTETİK MӘRKӘZ",
      "CHESS_TRAINING": "ŞAHMAT HAZIRLIQ KURSU",
      "MUSEUM": "MUZEY",
      "SELLING_BOTTLED_DRINKING_WATER": "QABLAŞDIRILMIŞ İÇMƏLİ SULARIN SATIŞI",
      "LOMBARD": "LOMBARD",
      "PRODUCTION_OF_PAINTS_VARNISHES_PRINTING_INKS_AND_MASTICS": "BOYA, LAK VӘ BUNA BƏNZӘR ÖRTÜKLӘRİN, MӘTBӘӘ BOYALARININ VӘ MASTIKALARININ İSTEHSALI",
      "INSTALL_ALARM_SYSTEMS_LIGHTNING_RODS_LIGHTING_ANTENNAS": "OĞURLUĞA QARŞI SİQNAL SİSTEMİ, İLDIRIM SİPƏRLƏRİ, İŞIQLANDIRICI SİSTEMLƏR, ANTENNALARIN QURAŞDIRILMASI ÜZRƏ XIDMәTLәR",
      "ART_WORKSHOP": "NƏQQAŞLIQ EMALATXANALARININ FƏALİYYӘTİ",
      "CAR_SHOWROOM": "AVTOMOBIL SƏRGİ SALONU",
      "SHAWARMA": "ŞAURMA",
      "NIGHT_ENTERTAINMENT_CLUB": "GECƏ ƏYLƏNCƏ KLUBU",
      "BUSINESS_AND_MANAGEMENT_CONSULTING_SERVICES": "KOMMERSİYA FƏALİYYƏTİ VƏ İDARƏETMƏ MƏSƏLƏLƏRİ ÜZRƏ SAİR MƏSLƏHƏTLƏR ÜZRƏ XİDMƏTLƏR",
      "LABORATORY": "LABORATORİYA",
      "FLORICULTURE_SEED_PRODUCTION": "GÜLLƏRİN VƏ ONLARIN TOXUMLARININ BECƏRİLMƏSİ",
      "PRODUCTION_OF_CONCRETE": "BETON İSTEHSALI",
      "PRODUCTION_OF_SEWING_THREADS": "TİKİŞ SAPLARININ İSTEHSALI",
      "CEMENT_SELLING": "SEMENTİN SATIŞI",
      "LAUNDRY": "ÇAMAŞIRXANA",
      "CAR_PARKING": "AVTODAYANACAQ",
      "WHOLESALE_AGENCY_SERVICES": "TOPDAN SATIŞI ÜZRƏ AGENTLİK FƏALYYƏTİ",
      "LAHMACUN_TURKISH_PIZZA": "LAHMACUN",
      "FREIGHT_TRANSPORTATION_OFFICE": "YÜK DAŞIMA OFİSİ",
      "FABRICATION_OF_DENTAL_PROSTHESES": "DİŞ VƏ PROTEZİN İSTEHSALI",
      "PRODUCTION_OF_BEE_PRODUCTS": "ARI BALININ VƏ ARI MUMUNUN İSTEHSALI",
      "SERVICES_RELATED_TO_PRINTING_WORKS": "ÇAP İŞLӘRİNİN YERİNƏ YETİRİLMӘSİ İLӘ ƏLAQƏDAR XİDMƏTLӘR",
      "RENTAL_HOUSING": "EV KİRAYƏSİ",
      "SELLING_MACHINE_TOOLS": "DƏZGAHLARIN SATIŞI",
      "RECEPTION_POINT_FOR_METALS_AND_OTHER_WASTE": "METAL VƏ DİGƏR TULLANTILARININ QƏBULU MƏNTƏQƏSİ",
      "POTTERY_PRODUCTION": "AQLAY İSTEHSALI",
      "PRODUCTION_OF_SOAPS_DETERGENTS_AND_CLEANING_AGENTS": "SABUN VƏ YUYUCU TOZLARIN, TƏMİZLƏYİCİ VƏ CİLALAYICI VASİTƏLƏRİN İSTEHSALI",
      "PRODUCTION_OF_WOODEN_CRATES_BOXES": "TAXTA TARALARIN (YEŞİKLƏRİN) İSTEHSALI",
      "WEDDING_DRESS_RENTAL": "GƏLİNLİK PALTARLARININ KİRAYƏSİ",
      "CAR_OIL_CHANGE_SERVICE": "YAĞDƏYİŞMƏ",
      "PRODUCTION_OF_REFRIGERATORS_AND_VENTILATION_EQUIPMENT": "SOYUDUCULARI VƏ VENTİLYASİYA AVADANLIQLARININ İSTEHSALI",
      "GROWING_FRUIT_TREE_AND_VEGETABLE_SEEDLINGS": "MEYVƏ TİNGLƏRİNİN VƏ TƏRƏVƏZ ŞTİLLƏRİNİN İSTEHSALI",
      "CONSULTATION_AND_DIAGNOSTIC_CENTER": "MÜALİCƏ DİAQNOSTİKA MƏRKƏZİ",
      "ANIMAL_TRAINING_AND_CARE_SERVICES": "HEYVANLARIN TƏLİMİ VƏ ONLARA QULLUQ",
      "KARAOKE_CLUB": "KARAOKE KLUB",
      "CAR_WASH_SERVICE": "AVTO YUMA",
      "SELLING_AUDIO_AND_VIDEO_RECORDINGS": "AUDİO VƏ VİDEO YAZILARININ SATIŞI",
      "PRODUCTION_OF_WIRE_PRODUCTS": "MƏFTİL İSTEHSALI",
      "COMPUTER_REPAIR": "KOMPÜTER TƏMİRİ",
      "COURIER_OR_DELIVERY_SERVICE": "KURYER VӘ YA ÇATDIRILMA XİDMӘTİ",
      "DRYWALL_SELLING": "ALÇİPANIN SATIŞ",
      "POTATO_CULTIVATION": "KARTOFUN BECƏRİLMƏSİ",
      "PRODUCTION_OF_LOCKS_AND_HINGES": "QIFIL VƏ HƏNCAMA İSTEHSALI",
      "FURNITURE_SHOWROOM": "MEBEL SƏRGİ SALONU",
      "BOILER_REPAIR": "KOMBİ TƏMİRİ",
      "JEWELRY_WORKSHOP": "ZƏRGƏRLİK XİDMӘTİ",
      "PRODUCTION_OF_FISH_PRODUCTS": "BALIQ MӘHSULLARININ İSTEHSALI",
      "CONSTRUCTION_MATERIALS_MARKET": "TIKINTI MATERIALLARI BAZARI",
      "SELLING_COFFEE_TEA_COCOA_AND_SPICES": "KOFE, ÇAY, KAKAO VӘ ƏDVİYYATIN SATIŞI",
      "MANUFACTURE_OF_SAWN_TIMBER": "TAXTA İSTEHSALI",
      "SELLING_SAND_AND_GRAVEL": "QUM VӘ ÇINQILIN SATIŞI",
      "IRON_GATES_PRODUCTION": "DӘMİR QAPI İSTEHSALI",
      "CULTIVATION_OF_OTHER_FRUITS": "DIGӘR MEYVӘLӘRİN BECƏRILMӘSI",
      "BASIC_TECHNOLOGICAL_PROCESSES_OF_MECHANICAL_ENGINEERING": "MAŞINQAYIRMANIN ƏSAS TEXNOLOJİ PROSESLӘRI",
      "CUSTOMS_SERVICES": "GÖMRÜK SAHӘSINDӘ XIDMӘTLӘR",
      "SUSHI": "SUŞI",
      "INSTALLATION_OF_ELECTRICAL_NETWORKS_AND_EQUIPMENT": "ELEKTRIK ŞӘBӘKӘSINDӘ VӘ CİHAZLARININ QURAŞDIRMA İŞLӘRI ÜZRӘ XIDMӘTLӘR",
      "ACTIVITIES_IN_THE_FIELD_OF_ARCHITECTURE": "MEMARLIQ SAHӘSINDӘ FӘALYYӘT",
      "PACKAGING_SERVICES": "QABLAŞDIRMA",
      "LOCAL_SELF_GOVERNANCE_ACTIVITIES": "YERLİ ÖZÜNÜ İDARӘETMӘ ORQANLARININ FӘALYYӘTİ",
      "CAR_RENTAL_SERVICES": "AVTOMOBILLƏRİN İCARӘSİ",
      "OTHER_EDUCATIONAL_SERVICES": "TӘHSIL SAHӘSINDӘ SAİR YARDIM GÖSTӘRILMӘSİ ÜZRӘ XIDMӘTLӘR",
      "CHILDREN_HAIRDRESSING": "UŞAQ SAÇ KӘSİMİ",
      "GLASS_PRODUCTION": "ŞÜŞӘ İSTEHSALI",
      "STONE_PRODUCTION": "DAŞ İSTEHSALI",
      "METAL_CASTING_AND_PRODUCTION_OF_VARIOUS_EQUIPMENT": "METALLARIN TÖKÜLMӘSİ VӘ MÜXTӘLİF AVADANLIQLARIN İSTEHSALI",
      "PRODUCTION_OF_VARIOUS_CLOTHING": "QARIŞIQ GEYİM İSTEHSALI",
      "PRODUCTION_OF_CAST_IRON_STEEL_AND_FERROALLOYS": "ÇUQUN, POLAD VӘ FERRO ƏRINTI İSTEHSALI",
      "HOSTEL": "HOSTEL",
      "LAW_CONSULTING_OFFICE": "HÜQUQ MӘSLӘHӘTXANASI",
      "PSYCHOLOGICAL_CENTER": "PSİXOLOGİYA MӘRKӘZİ",
      "TELECOMMUNICATION_ACTIVITIES": "TELEKOMMUNIKASİYA FӘALYYӘTİ",
      "GIFT_DECORATING_AND_WRAPPING_SERVICES": "ƏŞYALARIN BӘZӘDILMӘSI VӘ HӘDИYYӘLӘRİN QABLAŞDIRILMASI",
      "WATER_PRODUCTION": "SU İSTEHSALI",
      "PRODUCTION_OF_FRUIT_AND_VEGETABLE_JUICES": "MEYVӘ V Ә TƏRƏVƏZ ŞİRƏLƏRİNİN İSTEHSALI",
      "ATTRACTIONS_AND_WATER_PARKS": "ATRAKSION V Ə AQUAPARK",
      "FOOTBALL_SCHOOL": "FUTBOL MƏKTƏBİ",
      "SPICE_PRODUCTION": "ƏDVİYYAT İSTEHSALI",
      "GUEST_HOUSE": "QONAQ EVİ",
      "TOMATO_PRODUCTION": "TAMET İSTEHSALI",
      "STONE_QUARRY": "DAŞ KARXANASI",
      "RENTAL_OF_SPORTS_AND_LEISURE_GOODS": "İDMAN VƏ İSTİRAHƏT ÜÇÜN NƏZƏRDƏ TUTULMUŞ MALLARIN İCARƏSİ",
      "WEDDING_PHOTO_STUDIO": "BƏY-GƏLİN FOTO STUDİOSU",
      "ADHESIVE_PRODUCTION": "YAPIŞQAN İSTEHSALI",
      "SAND_AND_GRAVEL_QUARRY": "QUM-ÇINQIL KARXANASI",
      "SELLING_SPARE_PARTS": "PARÇALARIN SATIŞI",
      "SELLING_MEN_CLOTHING": "KİŞİ GEYİMLƏRİNİN SATIŞI",
      "PHOTO_STUDIO": "QARIŞIQ FOTO STUDİO",
      "PRODUCTION_OF_METAL_PIPES": "METAL BORU İSTEHSALI",
      "PRODUCTION_OF_TANKS_BUCKETS_AND_CONTAINERS": "SİSTERNLƏRİN, ÇƏNLƏRİN VƏ KONTEYNERLƏRİN İSTEHSALI",
      "TAX_SERVICE": "VERGİ XİDMƏTİ",
      "BLACKSMITH": "DƏMİRÇİ",
      "ZOO": "ZOOPARK",
      "PRODUCTION_OF_LAVASH_BREAD": "LAVAŞ İSTEHSALI",
      "GROCERY_MARKET": "ƏRZAQ MALLARI BAZARI",
      "QUTAB_HOUSE_FLATBREAD": "QUTABXANA",
      "MANUFACTURE_OF_CLOTHING_FOR_INDUSTRIAL_FACILITIES": "SƏNAYE OBYEKTLƏRİ ÜÇÜN GEYİM İSTEHSALI",
      "RENTAL_OF_OTHER_CLOTHES": "DIGƏR PALTARLARIN KİRAYƏSİ",
      "PRODUCTION_OF_PLASTIC_SHEETS_STRIPS_PIPES_AND_PROFILES": "PLASTİK LÖVHƏLƏRİN, ZOLAQLARIN, BORULARIN, PROFİLLƏRİN İSTEHSALI",
      "COMPUTER_SERVICES": "KOMPÜTER XİDMƏTLƏRİ",
      "AUDIT_SERVICES": "AUDİT XİDMƏTİ",
      "SELLING_COCKTAILS": "KOKTEYL SATIŞI",
      "REALTOR_SERVICES": "EV ALQI-SATQISI",
      "MANUFACTURE_OF_OTHER_RUBBER_PRODUCTS": "REZİNDƏN DİGƏR MƏMULATLARIN HAZIRLANMASI",
      "PRODUCTION_OF_BRICKS_TILES_FIRED_CLAY_BUILDING_MATERIALS": "KƏRPİC, KİRƏMİT VƏ YANDIRILMIŞ GİLDƏN SAİR TİKİNTİ MƏMULATLARININ İSTEHSALI",
      "GLASS_WASTE_COLLECTION_POINT": "ŞÜŞƏ QƏBULU MƏNTƏQƏSİ",
      "PREPARATORY_COURSES_FOR_UNIVERSITY_ENTRANTS_ABITURIENTS": "ABİTURİYENT HAZIRLIQ KURSU",
      "PRODUCTION_OF_STYROFOAM_EXPANDED_POLYSTYRENE": "PENOPLAST İSTEHSALI",
      "PRODUCTION_OF_CABLES": "KABEL İSTEHSALI",
      "PILATES_CENTER": "PİLATES MƏRKƏZİ",
      "COMPUTER_COURSES": "KOMPÜTER KURSU",
      "PRODUCTION_OF_PASTA_NOODLES_AND_SIMILAR_PRODUCTS": "MAKARON, ƏRİŞTƏ VƏ OXŞAR MƏMULATLARIN İSTEHSALI",
      "PATIENT_CARE": "XƏSTƏLƏRƏ QULLUQ",
      "PRODUCTION_OF_CONFECTIONERY_PRODUCTS": "XARRATLIQ MƏMULATLARININ İSTEHSALI",
      "INTERNET_PROVIDER_SERVICES": "İNTERNET TƏCHİZAT XİDMƏTİ",
      "SPORTS_AND_FITNESS_CENTER": "İDMAN VӘ SAĞLAMLIQ MӘRKӘZİ",
      "TOPAZ_AREA_REGION": "TOPAZ MӘNTӘQӘSİ",
      "CAR_DIAGNOSTICS": "AVTO DİAQNOSTİKA",
      "INTERNET_CLUB": "İNTERNET KLUB",
      "POST_OFFICE": "POÇT MӘRKӘZİ VӘ YA FİLİALI",
      "SHOE_REPAIR": "AYAQQABI TӘMİRİ",
      "CULTIVATION_OF_SPICES_PERFUME_PLANTS_AND_MEDICINAL_HERBS": "ƏDVİYYAT, ƏTRİYYAT VƏ DӘRMAN BİTKILӘRİNİN BECӘRILMӘSİ",
      "TRANSLATION_AGENCY": "TӘRCÜMӘ MӘRKӘZİ",
      "PHOTO_PRINTING_SHOP": "SURӘTÇIXARMA OBYEKTİ",
      "DECORATION_OF_TRAYS": "XONÇALARIN BӘZӘDILMӘSİ",
      "BATTERY_PRODUCTION": "AKKUMULYATORLARIN İSTEHSALI",
      "PRODUCTION_OF_FRUIT_AND_VEGETABLE_SNACKS": "MEYVӘ VƏ YA TӘRӘVӘZDƏN YEYİNTİ MӘHSULLARININ İSTEHSALI",
      "CANDY_STORE": "XƏNGƏLXANA",
      "PIE_SHOP": "PERAŞKİ",
      "CAR_TUNING": "AVTOTÜNİNQ",
      "CHILD_DEVELOPMENT_CENTRE": "UŞAQ İNKİŞAF MӘRKӘZİ",
      "SANATORIUM": "SANATORİYA",
      "ACCOMMODATION_SERVICES": "YAŞAYIŞI TӘMİN ETMӘKLӘ BAĞLI QULLUQ",
      "LOGOPEDIST_SERVICES": "LOQOPED",
      "SHEEP_AND_GOATS_BREEDING": "QOYUN VӘ KEÇİLӘRİN YETIŞDİRILMӘSİ",
      "COMPUTER_HALL": "KOMPÜTER SALONU",
      "REPAIR_AND_PRODUCTION_OF_AGRICULTURAL_AND_FORESTRY_TRACTORS": "KƏND TƏSƏRRÜFATI VӘ MEŞƏ TƏSƏRRÜFATI TRAKTORLARININ TӘMİRİ DƏZGAHLARIN İSTEHSALI",
      "EYEGLASSES_REPAIR": "EYNƏKLƏRİN TӘMİRİ",
      "STONE_MARKET": "DAŞ BAZARI",
      "PRODUCTION_OF_WOMEN_CLOTHING": "QADIN GEYİMİ İSTEHSALI",
      "PRODUCTION_OF_OILS_AND_FATS": "YAĞ VӘ PİYLӘRİN İSTEHSALI",
      "SPEECH_DEVELOPMENT_CENTER": "NİTQ VӘ İNKİŞAF MӘRKӘZİ",
      "BLINDS_PRODUCTION": "JALÜZ İSTEHSALI",
      "TOURIST_CAMPS": "TURİST DÜŞƏRGƏLƏRİ",
      "TURNING_WORK": "DÜLGƏRLİK FӘALYYӘTİ",
      "PRODUCTION_OF_CHILDREN_CLOTHING": "UŞAQ GEYİMİ İSTEHSALI",
      "COVER_REPAIR": "ÇEXOL TƏMİRİ",
      "PRODUCTION_OF_TOMBSTONES": "MƏZAR DAŞI İSTEHSALI",
      "ART_GALLERY": "RƏSM QALERİYASI",
      "DESIGN_COURSES": "DİZAYN KURSU",
      "PRODUCTION_OF_WINES_AND_WINE_MATERIALS": "ŞƏRABLAR VӘ ŞƏRAB MATERİALLARININ İSTEHSALI",
      "CURRENCY_EXCHANGE_OFFICE": "VALYUTA DƏYİŞMƏ MƏNTƏQƏSİ",
      "VIDEO_COPYING_SERVICE": "VİDEOYAZILARIN SURӘTİNİN ÇIXARILMASI",
      "BREWING": "PİVƏ İSTEHSALI",
      "WASTE_TREATMENT_AND_DISPOSAL": "TULLANTILARIN EMALI VƏ LƏĞV EDİLMƏSİ",
      "PRODUCTION_OF_NAPKINS": "SALFET İSTEHSALI",
      "REPAIR_OF_METAL_PRODUCTS": "METAL MƏMULATLARININ TƏMİRİ",
      "PRODUCTION_OF_SEALS_AND_STAMPS": "MÜXTƏLİF NÖV MÖHÜRLƏRİN VƏ ŞTAMPLARIN HAZIRLANMASI",
      "SELLING_NON_ALCOHOLIC_BEVERAGES": "ALKOQOLSUZ İÇKİLƏRİN SATIŞI",
      "EDUCATION_SERVICES": "TƏHSİL SAHƏSİ ÜZRƏ XİDMƏTLƏR",
      "DESIGN_WORK": "DİZAYN FƏALİYYƏTİ",
      "PRODUCTION_OF_MOLDED_DECOR": "LEPKA İSTEHSALI",
      "PRODUCTION_OF_STATIONERY_SUPPLIES": "DƏFTƏRXANA MƏMULATLARININ İSTEHSALI",
      "DORMITORY_SERVICES": "YATAQXANA",
      "WOMEN_COUNSELLING_CENTER": "QADIN MƏSLƏHƏTXANASI",
      "PRODUCTION_OF_AUTOMOTIVE_PAINTS": "AVTO BOYALARIN DÜZƏLDİLMƏSİ",
      "BICYCLE_REPAIR": "VELOSİPED TƏMİRİ",
      "CHEESE_AND_CURD_PRODUCTION": "PENDİR VƏ KƏSMİK İSTEHSALI",
      "SELLING_COMPUTERS_PERIPHERAL_DEVICES_AND_SOFTWARE": "KOMPÜTERLƏRİN, PERİFERİYA AVADANLIQLARININ VƏ PROQRAM TƏMİNATININ SATIŞI",
      "TEXTILE_PRODUCTION": "PARÇA İSTEHSALI",
      "PRODUCTION_OF_HOSIERY": "CORAB İSTEHSALI",
      "SELLING_BABY_FOOD": "UŞAQ QİDALARININ SATIŞI",
      "LIBRARY": "KİTABXANA",
      "CLEANING_SERVICE": "TƏMİZLƏMƏ XİDMƏTİ",
      "PRODUCTION_OF_CLOTHING_ACCESSORIES": "GEYİM AKSESUARLARININ İSTEHSALI",
      "VOCATIONAL_TRAINING_COURSES": "PEŞƏ HAZIRLIQ KURSU",
      "ADVISORY_SERVICES_FOR_AGRONOMISTS_AND_OTHER": "AQRONOMLAR, KƏND TƏSƏRRÜFATI İQTİSADÇILARIN VƏ FERMERLƏR ÜÇÜN MƏSLƏHӘTLӘR ÜZRӘ XİDMӘTLӘR",
      "BILLIARD_ROOM": "BİLYARD ZALI",
      "SELLING_GOLD": "QIZILIN SATIŞI",
      "MASSAGE_SALON": "MASSAJ SALONU",
      "SERVICES_FOR_PLANNING_EFFICIENCY_CONTROL": "PLANLAŞDIRMA, TƏŞKİL ETMӘ, SӘMӘRӘLİLİYİN VӘ NӘZARӘTİN TӘMİN EDILМӘSİ VӘ İDARӘETMӘ ÜÇÜN MӘLUMATIN TӘMİN EDILМӘSİ VӘ SAİR KOMMERSİYA MÜӘSSISӘLӘRI VӘ DÖVLӘT XİDMӘTLӘRI ÜZRӘ MӘSLӘHӘTLӘR VӘ ONLARA YARDIM GÖSTƏRILMӘSİ ÜZRӘ XIDMӘTLӘR",
      "SELLING_EGGS": "YUMURTANIN SATIŞI",
      "CLEANING_OF_BUILDINGS": "BİNALARIN TƏMİZLƏNMƏSİ VӘ YIĞIŞDIRILMASI",
      "SHOOTING_CENTER": "ATICILIQ MӘRKӘZİ",
      "PAINTING_OF_METAL_PRODUCTS": "METAL MƏMULATLARININ RƏNGLƏNMƏSİ",
      "PASSENGER_TRANSPORTATION_OFFICE": "SƏRNİŞİN DAŞIMA OFİSİ",
      "PRODUCTION_OF_WOODEN_DOORS_AND_WINDOWS": "TAXTA QAPI-PƏNCƏRƏ İSTEHSALI",
      "SWIMMING_COMPLEX": "ÜZGÜÇÜLÜK KOMPLEKSİ",
      "WELDER": "QAYNAQÇI",
      "PRODUCTION_OF_STRONG_DRINKS": "ARAQ (VODKA), TÜNDLƏŞDİRİLMİŞ İÇKİLƏR VӘ TÜNDLӘŞDİRILMİŞ İÇKİ MATERİALLARININ, LİKYOR VӘ LİKYOR MATERİALLARININ İSTEHSALI",
      "LABOUR_SUPPLY_ACTIVITIES": "ƏMƏK EHTİYATLARININ TƏQDİM EDILМӘSИ ÜZRӘ FӘALYYӘT",
      "ALUMINIUM_PRODUCTION": "ALÜMİNİUM İSTEHSALI",
      "COFFEE_PRODUCTION": "KOFE İSTEHSALI",
      "KEY_MAKING_AND_REPAIR": "AÇARLARIN HAZIRLANMASI VӘ TӘMİRİ",
      "FIREWOOD_PRODUCTION": "ODUN İSTEHSALI",
      "PRE_SCHOOL_TRAINING": "MƏKTƏBƏQƏDƏR HAZIRLIQ",
      "GAS_PRODUCTION": "QAZIN İSTEHSALI",
      "GARAGE": "QARAJ",
      "CATTLE_MARKET": "MAL-QARA BAZARI",
      "REPAIR_OF_MACHINES_AND_EQUIPMENT": "MAŞIN VӘ AVADANLIQLARIN TӘMİRİ",
      "EMPLOYMENT_CENTER": "İŞƏ DÜZӘLTMӘ MӘRKӘZİ",
      "CARING_FOR_ELDERLY_AND_DISABLED_PEOPLE": "QOCALAR VӘ ƏMӘK QABILIYYӘTİNİ İTIRMІŞ ŞӘXSLӘRЕ QULLUQ",
      "LOTTERY_GAMES": "LOTOREYA OYUNLARI",
      "RENTAL_OF_VIDEO_TAPES_AND_DISCS": "VİDEOLENTLƏRİN VƏ DİSKLƏRİN KİRAYƏSİ",
      "ACCOUNTING_SERVICES": "MÜHASİBAT XİDMƏTİ",
      "PRODUCTION_OF_ELECTRIC_LAMPS_AND_LIGHTING_EQUIPMENT": "ELEKTRİK LAMPALARI VƏ İŞIQLANDIRICI AVADANLIQLARIN İSTEHSALI",
      "WALLPAPER_PRODUCTION": "DİVAR KAĞIZLARININ İSTEHSALI",
      "AIRPORT_OPERATIONS": "HAVA LİMANLARININ FƏALİYYƏTİ",
      "MANAGEMENT_OF_APARTMENT_BUILDINGS": "ÇOXMƏNZİLLİ BİNALARIN İDARƏ OLUNMASI",
      "TOURIST_BASES": "TURBAZALAR",
      "INDUSTRIAL_GOODS_MARKET": "SƏNAYE MALLARI BAZARI",
      "PRODUCTION_OF_MUSICAL_INSTRUMENTS": "MUSİQİ ALƏTLƏRİNİN İSTEHSALI",
      "MANUFACTURE_OF_OTHER_WOODEN_PRODUCTS": "AĞACDAN SAİR MƏMULATLARIN HAZIRLANMASI",
      "FOREIGN_LANGUAGE_COURSES": "XARİCİ DİL KURSU",
      "BICYCLE_PRODUCTION": "VELOSİPEDLƏRİN İSTEHSALI",
      "CONSTRUCTION_OF_RESIDENTIAL_BUILDINGS": "MƏNZİL TİKİNTİSİ",
      "CLOTHING_REPAIR": "PALTARLARIN TƏMİRİ",
      "PRODUCTION_OF_LEMONADE": "LİMONAD İSTEHSALI",
      "DANCE_STUDIO": "RƏQS DƏRNƏYİ",
      "FAIR": "YARMARKA",
      "INSTALLATION_SERVICES_OF_FIRE_ALARM_SYSTEMS": "YANĞINA QARŞI SİQNAL SİSTEMLƏRİNİN QURAŞDIRILMASI ÜZRƏ XİDMƏTLƏR",
      "RESORT_AREA": "KURORT ZONA",
      "SELLING_GAS_PRODUCTS": "QAZ MƏHSULLARININ SATIŞI",
      "SELLING_LIFTING_EQUIPMENT": "YÜKQALDIRICI AVADANLIQLARIN SATIŞI",
      "PRODUCTION_OF_GATES": "DARVAZA İSTEHSALI",
      "FISH_FARMING": "BALIQLARIN YETİŞDİRİLMƏSİ",
      "SAUNA": "SAUNA",
      "PRODUCTION_OF_ESSENTIAL_OILS": "EFİR YAĞLARININ İSTEHSALI",
      "TILE_PRODUCTION": "PİLTƏ İSTEHSALI",
      "CONSULTING_SERVICES_IN_PUBLIC_RELATIONS_AND_INFORMATION": "İCTİMAİ ƏLAQƏLƏRİN SAXLANILMASI VӘ MƏLUMAT MÜBADİLƏSİ SAHƏSİNDA MƏSLӘHӘTLӘR ÜZRӘ XIDMӘTLӘR",
      "TOYS_PRODUCTION": "OYUNCAQLARIN İSTEHSALI",
      "CAR_DRY_CLEANING": "AVTOMOBİLLƏRİN KİMYƏVİ TƏMİZLƏNMƏSİ",
      "REPAIR_OF_HOUSEHOLD_APPLIANCES": "MƏİŞƏT AVADANLIQLARININ TƏMİRİ",
      "PRODUCTION_OF_CHOCOLATE": "ŞOKOLAD İSTEHSALI",
      "TOILET": "TUALET",
      "PRODUCTION_OF_PAPER_BAGS": "KAĞIZ PAKETLƏRİN İSTEHSALI",
      "WEAVING": "TOXUCULUQ FƏALİYYӘTİ",
      "PRODUCTION_OF_TOBACCO_PRODUCTS": "TÜTÜN MӘMULATLARININ İSTEHSALI",
      "CARPET_CLEANING": "XALÇA YUMA",
      "SELLING_CHOCOLATE": "ŞOKOLAD SATIŞI",
      "PROVISION_OF_SERVICES_TO_THE_MINING_INDUSTRY": "MƏDƏNÇIXARMA SƏNAYESİNİN DİGƏR SAHƏLƏRİNDA XİDMӘTLӘRİN GÖSTӘRILMӘSİ",
      "CAR_PRODUCTION": "AVTOMOBİLLƏRİN İSTEHSALI",
      "WEDDING_CAR_DECORATION": "GƏLİN MAŞINLARININ BƏZƏDİLMӘSİ",
      "PEAT_EXTRACTION": "TORF HASİLATI",
      "PROVISION_OF_OTHER_SOCIAL_SERVICES_WITHOUT_HOUSING": "DİGӘR QRUPLARA DAXIL EDILМӘYӘN YAŞAYIŞA TӘMİNATSIZ SAIR SOCİAL XİDMӘTLӘRİN GÖSTӘRILMӘSİ",
      "MANUFACTURE_OF_CARPETS_AND_CARPETING_PRODUCTS": "XALÇA VӘ XALÇA MӘMULATLARININ İSTEHSALI",
      "ACTIVITIES_OF_INFORMATION_AGENCIES": "MƏLUMAT AGENTLİKLӘRİNİN FӘALYYӘTİ",
      "TURNER": "TOKAR",
      "PUBLISHERS": "NƏŞRİYYAT",
      "MUSIC_LESSONS": "MUSİQİ HAZIRLIQ KURSU",
      "TEA_LEAF_CULTIVATION": "ÇAY YARPAĞININ BECƏRİLMӘSİ",
      "MANUFACTURE_OF_LEATHER_AND_LEATHER_GOODS": "DƏRİ VӘ DƏRİ MӘMULATLARININ İSTEHSALI",
      "STATE_ADMINISTRATIVE_BUILDING": "DÖVLӘT İNZİBATİ BİNASI",
      "RESEARCH_SERVICES_IN_NATURAL_AND_TECHNICAL_SCIENCES": "TƏBİİ VƏ TEXNİKİ ELMLƏR SAHƏSİNDƏ SAİR TƏDQİQATLAR ÜZRƏ XİDMӘTLӘR",
      "PRODUCTION_OF_PERFUMES_AND_COSMETICS": "ƏTRİYYAT VƏ KOSMETİKA VASİTƏLƏRİNİN İSTEHSALI",
      "PRODUCTION_OF_ELECTRONIC_COMPONENTS": "ELEKTRON DETALLARININ İSTEHSALI",
      "MEAT_MARKET": "ƏT BAZARI",
      "FERTILISER_PRODUCTION": "GÜBRƏ İSTEHSALI",
      "PAINTING_COURSE": "RƏSSAMLIQ KURSU",
      "SKI_SLOPES_OPERATIONS": "XİZƏK YOLLARININ İSTİSMARI",
      "EXPLOITATION_OF_DANCE_FLOORS": "RƏQS MEYDANÇALARININ İSTİSMARI",
      "SELLING_FUR_AND_LEATHER_GOODS": "XƏZ VƏ DƏRİ MƏMULATLARININ SATIŞI",
      "ACADEMY": "AKADEMİYA",
      "SELLING_CONFECTIONERY": "QƏNNADI MƏMULATLARININ SATIŞI",
      "CHILDREN_PHOTO_STUDIO": "UŞAQ FOTO STUDİOSU",
      "PRODUCTION_OF_SUNFLOWER_SEEDS": "GÜNƏBAXAN TUMLARININ İSTEHSALI",
      "PUMP_REPAIR": "NASOS TƏMİRİ",
      "ACCOUNTING_COURSES": "MÜHASİBATLIQ KURSU",
      "PRODUCTION_OF_PETROLEUM_PRODUCTS": "NEFT MƏHSULLARININ İSTEHSALI",
      "BREEDING_OF_OTHER_ANIMALS": "DİGƏR HEYVANLARIN YETİŞDİRİLMƏSİ",
      "SCHOOL": "MƏKTƏB",
      "PRODUCTION_OF_ELECTRIC_MOTORS_GENERATORS_TRANSFORMERS": "ELEKTRİK MÜHƏRRİKLƏRİNİN, GENERATORLARININ VƏ TRANSFORMATORLARININ İSTEHSALI",
      "PRODUCTION_OF_LEGUME_CROPS": "PAXLALI BİTKİLƏRİN İSTEHSALI",
      "PRODUCTION_OF_DIETARY_FOODS": "PƏHRİZ MƏHSULLARININ İSTEHSALI",
      "TIN_WORKER": "TƏNƏKƏÇİ",
      "RESTORATION_OF_FINE_ART_WORKS": "İNCƏSƏNƏT ƏSƏRLƏRİNİN BƏRPASI",
      "CAMPING": "KEMPİNQ",
      "THEATER": "TEATR",
      "MANUFACTURE_OF_KNIFE_PRODUCTS": "BIÇAQ MƏMULATLARININ İSTEHSALI",
      "GOAT_BREEDING": "QOZUN BECƏRİLMƏSİ",
      "HAIR_TRANSPLANTATION_CENTER": "SAÇ ƏKİM MƏRKӘZİ",
      "REPAIR_AND_MAINTENANCE_OF_VESSELS": "GƏMİLӘRİN TӘMİRİ VӘ ONLARA TEXNİKİ XİDMӘT",
      "SELLING_MUSICAL_INSTRUMENTS": "MUSİQİ ALӘTLӘRİNİN SATIŞI",
      "POST_PRODUCTION_EDITING_FILMS_VIDEO_AND_TV_PROGRAMS": "KİNOFİLMLӘRİN, VİDEO VӘ TELEVİZİYA PROQRAMLARININ HAZIRLANMASINDAN SONRA FӘALİYYӘT (YIĞILMASI)",
      "CLINIC_HOSPITAL": "XƏSTƏXANA",
      "HOSPITAL": "HOSPITAL",
      "COPPERWORKING": "MİSGƏRLİK FƏALİYYƏTİ",
      "CONSULTING_SERVICES_IN_VARIOUS_AREAS": "SAİR SAHƏLƏRDƏ MƏSLƏHƏTLƏRİN VERİLMƏSİ İLƏ BAĞLI FƏALİYYƏT",
      "ORGANIZATION_OF_CONGRESSES_AND_PROFESSIONAL_EXHIBITIONS": "KONQRESSLƏRİN VƏ PEŞƏKAR SALONLARIN TƏŞKİLİ",
      "PREPARATION_OF_CERAMIC_PRODUCTS": "SAXSI MƏMULATLARININ HAZIRLANMASI",
      "PRODUCTION_OF_CERAMIC_PRODUCTS": "SAXSI MƏMULATLARIN IN İSTEHSALI",
      "BUSINESS_AND_MANAGEMENT_SERVICES": "KOMMERSİYA FƏALİYYƏTİ VƏ İDARƏETMƏ MƏSƏLƏLƏRİ ÜZRƏ SAİR FƏALİYYƏT ÜZRƏ XİDMƏTLƏR"
    },
    "storeActivityLevelsOfDetail": {
      "general": "Ümumi",
      "main": "Yüksək",
      "middle": "Orta",
      "lower": "Aşağı"
    },
    "storeActivityByLevelsOfDetail": "Fəaliyyət növü detalizasiya səviyyəsi üzrə"
  },
  "user": {
    "accessRights": "Giriş hüquqları",
    "deactivationDate": "Deaktivasiya tarixi",
    "email": "E-poçt",
    "firstName": "Ad",
    "lastName": "Soyad",
    "middleName": "Ata adı",
    "mobilePhone": "Mobil nömrə",
    "password": "Şifrə",
    "phone": "Telefon nömrəsi",
    "roles": "Rollar",
    "roleTypes": {
      "CENTRAL_INSPECTOR": "Mərkəzi müfəttiş",
      "DIRECTOR": "Direktor",
      "EXPERT": "Ekspert",
      "AUDITOR": "Müşahidə aparan",
      "INSPECTOR": "Müfəttiş",
      "OPERATOR": "Operator",
      "TAXPAYER": "Vergi ödəyicisi",
      "REGIONAL_INSPECTOR": "Ərazi müfəttişi",
      "ADMIN": "Administrator"
    },
    "userName": "İstifadəçi adı",
    "userRoles": " İstifadəçi rolları",
    "userStatus": "İstifadəçi statusu",
    "userStatuses": {
      "ACTIVE": "Aktiv",
      "DELETED": "Silinib",
      "INACTIVE": "Aktiv olmayan"
    },
    "verificationCode": "Yoxlama kodu",
    "additionalUserRoles": "Əlavə rollar",
    "userRole": "İstifadəçi rolu"
  },
  "inspection": {
    "productName": "Əldə olunan malın adı",
    "inspectionResult": "Yoxlamanın nəticələri",
    "completionDate": "Yoxlamanın yekunlaşma tarixi",
    "resultComment": "Müşahidə aparanın yoxlamanın nəticələrinə dair şərhləri",
    "errors": {
      "createInspectionError": "Yoxlamanı təyin etmək mümkün olmadı",
      "notClosedInspectionAlreadyExists": "Cari yoxlamaya yekunlaşmadan, yeni yoxlama təyin oluna bilməz",
      "cancelInspectionError": "Yoxlamanı ləğv etmək mümkün olmadı",
      "assignInspectionError": "Yoxlamanı başlayan kimi qeyd etmək mümkün olmadı",
      "emptyResult": "Yoxlamanın nəticələrini seçin",
      "completeInspectionError": "Yoxlamanı yekunlaşdırmaq mümkün olmadı",
      "inspectionDateError": "Yoxlamanın aparılma vaxtı və saatı cari vaxtan böyük ola bilməz",
      "productNameError": "Əldə olunan əmtəənin adı boş buraxıla bilməz və özündə {{maxLength}} qədər simvol ehtiva etməlidir"
    },
    "inspectionsHistory": "Obyek üzrə yoxlama tarixləri",
    "createInspection": "Yoxlama təyin etmək",
    "assignInspection": "Yoxlamanı başlamaq",
    "completeInspection": "Yoxlamanı yekunlaşdırmaq",
    "cancelInspection": "Yoxlamanı ləğv etmək",
    "inspectionInitiatorComment": "Yoxlamanı təyin edənin şərhləri",
    "confirmCancelInspection": "Yoxlamanı həqiqətən ləğv etmək istəyirsiniz?",
    "confirmAssignInspection": "Yoxlamanı həqiqətən başlamaq istəyirsiniz?",
    "assignedDate": "Yoxlama başlayıb",
    "initiator": "Təyin edən",
    "inspectionStatuses": {
      "OPEN": "Acıq",
      "IN_PROGRESS": "İcra olunur",
      "CLOSED": "Bağlı"
    },
    "inspectionResults": {
      "RECEIPT_OK": "Kassa çeki təqdim olunub",
      "NO_RECEIPT": "Kassa çeki təqdim olunmayıb",
      "STORE_CLOSED": "Obyekt bağlıdır",
      "STORE_NOT_FOUND": "Obyekt tapılmadı",
      "CASHBOX_NOT_FOUND": "NKA yoxdur"
    },
    "inspectionDate": "Yoxlamanın aparılma tarixi",
    "inspectionPeriod": "Yoxlama periodu",
    "inspectionStatus": "Yoxlama üzrə vəziyyət"
  },
  "downloadings": {
    "delayedDownloadings": "Təxirə salınan yükləmələr",
    "errors": {
      "failedToGetDelayedDownloadings": "Təxirə salınan yükləmələr siyahısını əldə etmək mümkün olmamışdır",
      "failedToPollDelayedDownloadings": "Təxirə salınan yükləmələr siyahısını yeniləmək mümkün olmamışdır",
      "requestToCreateFileFailed": "Faylın yaradılması üzrə sorğu yerinə yetirilmədi.Təxirə salınan yükləmələr üzrə məhdudiyyətləri yoxlayın"
    },
    "downloadingTypes": {
      "OPERATORS": "Operatorlar",
      "COMPANIES": "Vergi ödəyiciləri",
      "STORES": "Obyektlər",
      "CASHBOXES": "NKA-lar",
      "DOCUMENTS": "Kassa çekləri",
      "DEVICES": "NMQ-lər",
      "REPORT_CASH_BOX_DAY": "Günlər üzrə hesabat",
      "REPORT_CASH_BOX": "NKA-lar üzrə hesabat"
    },
    "downloadingStatuses": {
      "CREATED": "Sorğu qəbul olundu",
      "IN_PROGRESS": "Formalaşır",
      "READY": "Hazırdır",
      "ERROR": "Xəta"
    },
    "downloadingErrors": {
      "MAX_ROWS_COUNT": "Excel faylının formatında xəta. Sətir sayı limiti keçib"
    },
    "downloadingRequestedDate": "Sorğunun tarixi",
    "limitationsHintDays": "Yükləmələr üzrə hazırlanmış fayllara dair saxlama müddəti {{limit}} gün",
    "limitationsHintItems": "Fayların maksimal sayı - {{limit}}",
    "fileCreationRequestAccepted": "Fayl yaratmaq üçün sorğu qəbul edildi. Xahiş olunur təxirə salınan yükləmələrin siyahısına baxın"
  },
  "ServiceScreen": {
    "hints": {
      "onlinePhisicalFDVersion": "Əməliyyat NKA-lar üçün onlayn rejimdə əlçatandır, fiskal sürücünün versiyası {{param}} və ya daha yüksək olmalıdır",
      "onlinePhisicalOrSoftwareFDVersion": "Əməliyyat NKA-lar üçün onlayn rejimdə fiziki və ya proqram kassaları üçün əlçatandır, fiskal sürücünün versiyası {{param}} və ya daha yüksək olmalıdır",
      "addCashboxesForOperation": "Əməliyyatın icrası üçün NKA-ları əlavə edin",
      "addCashboxes": "Zəhmət olmasa, NKA-ları əlavə edin",
      "limitForNumberOfCashboxes": "Siz {{limit}} qədər kassa əlavə edə bilərsiz",
      "limitForOneCashbox": "Yalnız bir NKA əlavə edə bilərsiz",
      "showOperationData": "Əməliyyatları göstər",
      "selectTargetVersion": "Hədəf olan versiyanı seçin",
      "deleteAllCashboxes": "Bütün NKA-ları sil",
      "deleteCashbox": "NKA-ni sil",
      "operationSuccessful": "Əməliyyat uğurla icra edildi",
      "performOperationConfirmation": "Seçilmiş NMQ siyahısı üçün \"{{operationType}}\" əməliyyatını icra etmək istəyirsiniz?",
      "deviceAlreadyInList": "Bu NMQ artıq siyahıdadır",
      "deleteAllDevices": "NMQ-ləri sil",
      "addDevices": "Əməliyyatın icrası üçün NMQ-ləri əlavə edin",
      "minFwVertionForOperation": "{{param}} və ya daha yuxarı versiya olan NMQ proqram təminatı",
      "selectAllCashboxesForOperation": "Əməliyyatın həyata keçirilməsi üçün bütün NKA-ları seç",
      "selectCashboxForOperation": "Əməliyyatın həyata keçirilməsi üçün NKA seç",
      "limitForNumberOfDevices": "Siz {{limit}} qədər NMQ əlavə edə bilərsiz"
    },
    "errors": {
      "failedToCreateCashboxesTasks": "Kassalar siyahısı üçün əməliyyatın icrasını sorğulamaq mümkün olmadı",
      "failedToGetCashboxesTasksStatuses": "Kassalar siyahısı üçün əməliyyatın icra statusunu əldə etmək mümkün olmadı",
      "failedToLoadFactoryNumbersList": "Qəbul edilən zavod nömrələrinin siyahısını yükləmək mümkün olmadı"
    },
    "dropZoneText": ".json və ya .csv faylını bura əlavə edin və ya seçmək üçün klikləyin",
    "initialisationOperationsTypes": {
      "PRODUCE": "Produce",
      "RESERVE": "Reserve",
      "UNRESERVE": "Unreserve",
      "USB_TYPE": "Usb type"
    },
    "serviceOperationTypes": {
      "BREAK": "Break",
      "UNBREAK": "Unbreak",
      "LOSE": "Lose",
      "LOSE_ROLLBACK": "Unlose",
      "SUPPORT": "To service",
      "SUPPORT_ROLLBACK": "Unsupport",
      "DELETE": "Delete"
    },
    "addDeviceToList": "NMQ-nin siyahı əlavə olunması",
    "serviceOperations": "Digər servis əməliyyatları",
    "deviceInitialization": "NMQ-nin initializasiyası",
    "enterPinCode": "Xahiş edirik PIN kodu daxil edin",
    "pinCode": "PİN kod",
    "dumpOperationTitle": "NMQ-dən dump məlumatları",
    "saveDump": "Dump faylı yadda saxla",
    "allowWithDocumentUnsent": "Göndərilməmiş cek ilə icazənin verilməsi",
    "allowWithShiftOpened": "Bağlanmamış növbə ilə icazənin verilməsi",
    "repairOperationTitle": "NMQ-nin bərpası",
    "repairDevice": "NMQ-ni bərpa et",
    "newAdminPinCode": "Administratorun yeni PİN kodu",
    "newAdminPukCode": "Administratorun yeni PUK kodu",
    "newUserPinCode": "Istifadəçinin yeni PİN kodu",
    "newUserPukCode": "Istifadəçinin yeni PUK kodu",
    "adminPinCode": "Administratorun PİN kodu"
  }
}
